import  { useState, useRef, useCallback, useEffect } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import Radio from '@mui/material/Radio';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';

import Fab from '@mui/material/Fab';



import ListItemText from '@mui/material/ListItemText';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ListItemButton from '@mui/material/ListItemButton';
import Typography from '@mui/material/Typography';
import Loader3 from './Loader3';
import Modal from '@mui/material/Modal';
import Paper from '@mui/material/Paper';
import { APICall } from './services/api.service';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from "./redux/actions"

import Divider from '@mui/material/Divider';


import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { APIvar } from '../services/variables';
import styles from './NadzoriUpravljanjeDnevnimSpiskovima.module.css'
import { componentStyles } from '../services/elementDesign'
import { toast } from 'react-toastify';

import { useNavigate } from "react-router-dom";
import { AiOutlineConsoleSql } from 'react-icons/ai';

const useColor = APIvar.colorUse;
const thirdColor = APIvar.colorTerciary;
const backColor = APIvar.colorBackground;
const cardBackColor = APIvar.cardBackgrounColor;

document.documentElement.style.setProperty('--backColor', backColor);
document.documentElement.style.setProperty('--cardBackColor', cardBackColor);


const theme = createTheme({
    palette: {
        primary: {
            main: '#520074'
        }
    },
});

const NadzoriUpravljanjeDnevnimSpiskovima = () => {

    const [isLoading, setLoading] = useState(false);
    const dispatch = useDispatch()


    const navigate = useNavigate();

    const [openModal, setOpenModal] = useState(false);

    const [displayedComponent, setDisplayedComponent] = useState(null);
    const [currentStates, setCurrentStates] = useState([]);
    const [currentDonat, setCurrentDonat] = useState([]);
    const [currTime, setCurrTime] = useState('');
    
    const token = localStorage.getItem("token");

    //const { user: currentUser } = useSelector((state) => state.auth);
    const user = localStorage.getItem("user");
    const username = localStorage.getItem("username");
    const ref = localStorage.getItem("id");


    const [tkListOstali, setTkListOstali] = useState([10, 11, 35, 40, 42, 44, 45, 49, 50, 60, 63, 66, 68, 88, 99, 999]);
    const [tkListA1, setTkListA1] = useState([22, 23]);
    const [tkListTele, setTkListTele] = useState([77]);
    const [tkListTMob, setTkListTMob] = useState([55]);
    const [tkListDonat, setTkListDonat] = useState([33]); 

    const [tkID, setTkID] = useState([]);


    const toastError = {                                                        
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
   };

   const toastSuccess = {                                                        
             position: "top-center",
             autoClose: 2000,
             hideProgressBar: false,
             closeOnClick: true,
             pauseOnHover: false,
             draggable: true,
             progress: undefined,
             theme: "light",
   };

   const toastInfo = {                                                        
             position: "top-center",
             autoClose: 2000,
             hideProgressBar: false,
             closeOnClick: true,
             pauseOnHover: false,
             draggable: true,
             progress: undefined,
             theme: "light",
   };

   const [isDragging, setIsDragging] = useState(false)
   const [modalPosition, setModalPosition] = useState({x:0,y:0})
   const startPosition = useRef({x:'100px',y:'100px'})
   const popupRef = useRef(null)


   const [showDetails, setShowDetails] =useState("")


   const onMouseUp = () => {
    setIsDragging(false);
  };

  const onMouseDown = (e) => {
    console.log("on mouse down")
    e.stopPropagation();
    setIsDragging(true);
    startPosition.current = { x: e.clientX - modalPosition.x, y: e.clientY - modalPosition.y }

  }

  const onMouseMove = useCallback((e) => {
    //console.log(e.clientx, startPosition);
  if (!isDragging) return;
  setModalPosition({
    x: e.clientX - startPosition.current.x,
    y: e.clientY - startPosition.current.y,
  });
},
[isDragging]
);
useEffect(() => {
    window.addEventListener("mousemove", onMouseMove);
    window.addEventListener("mouseup", onMouseUp);
    return () => {
      window.removeEventListener("mousemove", onMouseMove);
      window.removeEventListener("mouseup", onMouseUp);
    };
  }, [onMouseMove]);


    useEffect(()=>{
        //getListofCurrentStates()
        let tmp = new Date();


        console.log(tmp);
    
        tmp.setMinutes(tmp.getMinutes() - 25);
    
        console.log(tmp);
    
        let timeNow = tmp.getDate() + "." + (tmp.getMonth() + 1) + "." + tmp.getFullYear() + "." + " " + tmp.getHours() + ":" + tmp.getMinutes();
    
        console.log(timeNow);
    
        setCurrTime(timeNow);

        getDoneFilters()
    
    }, [])


    useEffect(()=>{
            document.title="Nadzor"
    },[])

    const [donatLast, setDonatLast] = useState('');
    const [donatLast_ak1, setDonatLast_ak1] = useState('');
    const [donatLast_ak2, setDonatLast_ak2] = useState('');
    const [donatLast_ak3, setDonatLast_ak3] = useState('');
    const [donatLast_ak4, setDonatLast_ak4] = useState('');
    const [donatLast_ak5, setDonatLast_ak5] = useState('');
    const [donatLast_ak6, setDonatLast_ak6] = useState('');
    const [tmobileLast, setTMobileLast] = useState('');
    const [tmobileLast_ak1, setTMobileLast_ak1] = useState('');
    const [tmobileLast_ak2, setTMobileLast_ak2] = useState('');
    const [tmobileLast_ak3, setTMobileLast_ak3] = useState('');
    const [tmobileLast_ak4, setTMobileLast_ak4] = useState('');
    const [tmobileLast_ak5, setTMobileLast_ak5] = useState('');
    const [tmobileLast_ak6, setTMobileLast_ak6] = useState('');
    const [a1Last, setA1Last] = useState('');
    const [a1Last_ak1, setA1Last_ak1] = useState('');
    const [a1Last_ak2, setA1Last_ak2] = useState('');
    const [a1Last_ak3, setA1Last_ak3] = useState('');
    const [a1Last_ak4, setA1Last_ak4] = useState('');
    const [a1Last_ak5, setA1Last_ak5] = useState('');
    const [a1Last_ak6, setA1Last_ak6] = useState('');

    const [teleLast, setTeleLast] = useState('');
        const [teleLast_ak1, setTeleLast_ak1] = useState('');
    const [teleLast_ak2, setTeleLast_ak2] = useState('');
    const [teleLast_ak3, setTeleLast_ak3] = useState('');
    const [teleLast_ak4, setTeleLast_ak4] = useState('');
    const [teleLast_ak5, setTeleLast_ak5] = useState('');
    const [teleLast_ak6, setTeleLast_ak6] = useState('');
    const [ostaliLast, setOstaliLast] = useState('');
    const [ostaliLast_ak1, setOstaliLast_ak1] = useState('');
    const [ostaliLast_ak2, setOstaliLast_ak2] = useState('');
    const [ostaliLast_ak3, setOstaliLast_ak3] = useState('');
    const [ostaliLast_ak4, setOstaliLast_ak4] = useState('');
    const [ostaliLast_ak5, setOstaliLast_ak5] = useState('');
    const [ostaliLast_ak6, setOstaliLast_ak6] = useState('');
                                                       



    const getDoneFilters =async () => {
            dispatch(actions.isLoading());

            
            APICall(

                '/GetFilterData',
                
                {

                    platform: '0',
                    version:'1.0',


                },
                {
                    token
                }).then(


                    (response) => {
                    
                        dispatch(actions.isNotLoading());

                        if(response==undefined) dispatch(actions.isNotLoading());

                        if(response.status==200){
                    
                                console.log("Gotten filterData!!!");
                                console.log(response.data);
                                if(response.data){
                                        


                                                let filData = response.data;
                                    
                                                if(filData.donat && filData.donat!=''){

                                                    console.log(filData.donat);

                                                    setDonatLast_ak1(filData.donat.ak1);
                                                    setDonatLast_ak2(filData.donat.ak2);
                                                    setDonatLast_ak3(filData.donat.ak3);
                                                    setDonatLast_ak4(filData.donat.ak4);
                                                    setDonatLast_ak5(filData.donat.ak5);
                                                    setDonatLast_ak6(filData.donat.ak6);

                                                    //setDonatLast(filData.donat)

                                                }
                                                if(filData.tmobile && filData.tmobile!=''){


                                                    setTMobileLast_ak1(filData.tmobile.ak1)
                                                    setTMobileLast_ak2(filData.tmobile.ak2)
                                                    setTMobileLast_ak3(filData.tmobile.ak3)
                                                    setTMobileLast_ak4(filData.tmobile.ak4)
                                                    setTMobileLast_ak5(filData.tmobile.ak5)
                                                    setTMobileLast_ak6(filData.tmobile.ak6)

                                                    //setTMobileLast(filData.tmobile)

                                                }
                                                if(filData.a1 && filData.a1!=''){

                                                    setA1Last_ak1(filData.a1.ak1)
                                                    setA1Last_ak2(filData.a1.ak2)
                                                    setA1Last_ak3(filData.a1.ak3)
                                                    setA1Last_ak4(filData.a1.ak4)
                                                    setA1Last_ak5(filData.a1.ak5)
                                                    setA1Last_ak6(filData.a1.ak6)
                                                    //setA1Last(filData.a1)

                                                }
                                                if(filData.tele && filData.tele!=''){

                                                    setTeleLast_ak1(filData.tele.ak1)
                                                    setTeleLast_ak2(filData.tele.ak2)
                                                    setTeleLast_ak3(filData.tele.ak3)
                                                    setTeleLast_ak4(filData.tele.ak4)
                                                    setTeleLast_ak5(filData.tele.ak5)
                                                    setTeleLast_ak6(filData.tele.ak6)

                                                    //setTeleLast(filData.tele)

                                                }
                                                if(filData.ostali && filData.ostali!=''){

                                                    setOstaliLast_ak1(filData.ostali.ak1)
                                                    setOstaliLast_ak2(filData.ostali.ak2)
                                                    setOstaliLast_ak3(filData.ostali.ak3)
                                                    setOstaliLast_ak4(filData.ostali.ak4)
                                                    setOstaliLast_ak5(filData.ostali.ak5)
                                                    setOstaliLast_ak6(filData.ostali.ak6)

                                                    //setOstaliLast(filData.ostali)

                                                }
                                               



                                
                                                    
                                }

                        } else {

                            if(response.status == 401){

                                    console.log("Istekla sesija");
            
                                    toast.error(response.data.message, toastError);
                                    
                                    dispatch(actions.logOut());
                                    navigate('/');

                            } else {
                                    //toast.error(response.data.message,
                                    //    toastError);
                                                        

                            }
        
                    
                        }        
                    
                    },

                    (error) => {

                        dispatch(actions.isNotLoading());

                    
                    


                    
                                if(!error.response){

                                    //toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                    //    toastError);
                                


                                } else {


                                    if(!error.response.status){

                                        //toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                        //toastError);

                                    }else{

                                        if (error.response.status == 401) {
                    
                                
                                            toast.error(error.response.data.message,
                                                    toastError);
                                            
                                                    setTimeout(() => {
                                                        dispatch(actions.logOut());
                                                        navigate('/');
                                                    }, 5000);   

                                        
                                    
                                        } else {
                                    
                                    
                                                   // toast.error(error.response.data.message,
                                                    //    toastError);
                                                                                
                                            
                                        }
                                    }
                                }
                            
                        
                    
                    
                    });



    }

    const getListofCurrentStates = async () => {
         dispatch(actions.isLoading());
        await APICall("/GetListCurrentState",  {

            platform: '0',
            version:'1.0'

        },
       {
           token
       }).then(response => {
        console.log(response)
        //setCurrentStates(response.data.list)
        dispatch(actions.isNotLoading());
        //setOpenModal(true);

        if(response.data && response.data.listaSvi && response.data.listaSvi.length!=0){

            let listTmp=response.data.listaSvi;

            setListAll (listTmp);

            console.log("Dobiveno listAll:");
            console.log(listTmp);

            
            
        }

        if(response.data && response.data.listaUkupno && response.data.listaUkupno.length!=0){

            let list=response.data.listaUkupno;

            setListUkupno (list);

            console.log("Dobiveno listUkupno:");
            console.log(list);  
            
        }

        if(response.data && response.data.listaDonat && response.data.listaDonat.length!=0){

            let listDonatTmp = response.data.listaDonat;

            setListDonat(listDonatTmp);
            console.log(listDonatTmp)
        }
        setCurrentStates(response.data.listaSvi);
        setCurrentDonat(response.data.listaDonat);

        setOpenModal(true);

        
       }).catch(error=> {

           dispatch(actions.isNotLoading());
       })
    }



    const trenutnoStanjeSpiskovaButtonFunction = () => {
         dispatch(actions.isLoading());
        console.log("Trenutno stanje spiskova")
        getListofCurrentStates();
        //setDisplayedComponent('div2');
        //setOpenModal(true);
        //dispatch(actions.isNotLoading());
    }



    const mjesecniIzvjestajoStanjuSpiskovaButtonFunction = () => {
         dispatch(actions.isLoading());
        console.log("Mjesecni izvjeŠtaj o stanju spiskova")
        setDisplayedComponent('div3');
        dispatch(actions.isNotLoading());
    }


    const naknadnoOsvjeziStatistikeButtonFunction = () => {
         dispatch(actions.isLoading());
        console.log("Naknadno osvježi statIstikU")
        dispatch(actions.isNotLoading());
    }


    const listActions=[{index:1, "title": "Brisanje knjiženih isključenja kojih nema u bijelim stranicama, po svim županijama"},
                        {index: 2, "title": "Telefone iz knjiženih isključenja odraditi u bijelim stranicama (status 7) i žutim stranicama (briši)"},
                        {index: 3, "title": "Makni uklj/isklj/promjene čijih telefona nema u 'buretu' niti u bijelim stranicama"},
                        {index: 4, "title": "Makni suvišna uključenja s liste (već prešli drugom operateru)"},
                        {index: 5, "title": "Zanemari sitne i nebitne korekcije iste firme"},
                        {index: 6, "title": "Makni prazne promjene (mob) i prelaske na fizička lica"}];


    const mockData = listActions.map(({index, title}) => ({
        id: index,
        title: `Akcija ` + index + `: ` + title,
        donat: {
            date: currTime,
            //time: 'Time',
            number: 'Val', // Replace with your desired value
        },
        tMobile: {
            date: currTime,
            //time: 'Time',
            number: 'Val', // Replace with your desired value
        },
        ostaliFiks: {
            date: currTime,
            //time: 'Time',
            number: 'Val', // Replace with your desired value
        },
        tele2: {
            date: currTime,
            //time: 'Time',
            number: 'Val', // Replace with your desired value
        },
        vipnet: {
            date: currTime,
            //time: 'Time',
            number: 'Val', // Replace with your desired value
        },
    }));

    const [checkedCheckboxes, setCheckedCheckboxes] = useState({});
    
    
    const handleCheckboxChange = (dataId, feald) => {




        console.log(dataId);
        console.log(feald);
        setCheckedCheckboxes((prevChecked) => ({
            ...prevChecked,
            [dataId]: {
                ...prevChecked[dataId],
                [feald]: !prevChecked[dataId]?.[feald],
            },
        }));
        console.log(checkedCheckboxes)
    };




    const  handleDonat=async()=>{

        console.log("Calling all functions for Donat");


        dispatch(actions.isLoading());


        let rez1 = await callAction1([33]);

        console.log("Awaited first, calling second");


        let rez2 = await callAction2([33]);

        console.log("Awaited second, calling third");

        let rez3 = await callAction3([33]);

        console.log("Awaited third, calling fourth");

        let rez4 = await callAction4([33]);

        console.log("Awaited fourth, calling fifth");

                

        let rezTmp = await callActionDel([33]);

        console.log("Awaited fifth, calling end");

        let rez5 = await callAction5([33]);

        console.log("finally fifth!!");

        


        

        console.log("Izvrseno sve!");


    }

    
    const handleTMobile=async ()=>{

        console.log("Calling all functions for T-Mobile");

        console.log(checkedCheckboxes[1]);
        console.log(checkedCheckboxes[2]);
        console.log(checkedCheckboxes[3]);
        console.log(checkedCheckboxes[4]);
        console.log(checkedCheckboxes[5]);
        console.log(checkedCheckboxes[6]);

        dispatch(actions.isLoading());

        let rez1 = await callAction1([55]);

        console.log("Awaited first, calling second");

        let rez2 = await callAction2([55]);

        console.log("Awaited second, calling third");

        let rez3 = await callAction3([55]);

        console.log("Awaited third, calling fourth");

        let rez4 = await callAction4([55]);

        console.log("Awaited fourth, calling fifth");

        let rezTmp = await callActionDel([55]);

        console.log("Awaited fifth, calling end");

        let rez5 = await callAction5([55]);

        console.log("finally fifth!!");



        console.log("Izvrseno sve!");


    }

    const handleOstali=async ()=>{

        console.log("Calling all functions for Ostali");

        console.log(checkedCheckboxes[1]);
        console.log(checkedCheckboxes[2]);
        console.log(checkedCheckboxes[3]);
        console.log(checkedCheckboxes[4]);
        console.log(checkedCheckboxes[5]);
        console.log(checkedCheckboxes[6]);

        dispatch(actions.isLoading());


        let rez1 = await callAction1([10, 11, 35, 40, 42, 44, 45, 49, 50, 60, 63, 66, 68, 88, 99, 999]);

        console.log("Awaited first, calling second");

        let rez2 = await callAction2([10, 11, 35, 40, 42, 44, 45, 49, 50, 60, 63, 66, 68, 88, 99, 999]);

        console.log("Awaited second, calling third");

        let rez3 = await callAction3([10, 11, 35, 40, 42, 44, 45, 49, 50, 60, 63, 66, 68, 88, 99, 999]);

        console.log("Awaited third, calling fourth");

        let rez4 = await callAction4([10, 11, 35, 40, 42, 44, 45, 49, 50, 60, 63, 66, 68, 88, 99, 999]);

        console.log("Awaited fourth, calling fifth");

        let rez5 = await callAction5([10, 11, 35, 40, 42, 44, 45, 49, 50, 60, 63, 66, 68, 88, 99, 999]);

        console.log("finally fifth!!");



        console.log("Izvrseno sve!");


    }

    const handleTele=async ()=>{

        console.log("Calling all functions for Tele2");

        console.log(checkedCheckboxes[1]);
        console.log(checkedCheckboxes[2]);
        console.log(checkedCheckboxes[3]);
        console.log(checkedCheckboxes[4]);
        console.log(checkedCheckboxes[5]);
        console.log(checkedCheckboxes[6]);

        dispatch(actions.isLoading());

        let rez1 = await callAction1([77]);

        console.log("Awaited first, calling second");

        let rez2 = await callAction2([77]);

        console.log("Awaited second, calling third");

        let rez3 = await callAction3([77]);

        console.log("Awaited third, calling fourth");

        let rez4 = await callAction4([77]);

        console.log("Awaited fourth, calling fifth");

        let rez5 = await callAction5([77]);

        console.log("finally fifth!!");

        console.log("Izvrseno sve!");


    }

    const handleA1=async ()=>{

        console.log("Calling all functions for A1");

        //setLoading(true);

        dispatch(actions.isLoading());

        console.log(checkedCheckboxes[1]);
        console.log(checkedCheckboxes[2]);
        console.log(checkedCheckboxes[3]);
        console.log(checkedCheckboxes[4]);
        console.log(checkedCheckboxes[5]);
        console.log(checkedCheckboxes[6]);



     let rez1 = await callAction1([22, 23]);

     console.log("Awaited first, calling second");

     let rez2 = await callAction2([22, 23]);

     console.log("Awaited second, calling third");

     let rez3 = await callAction3([22, 23]);

     console.log("Awaited third, calling fourth");

     let rez4 = await callAction4([22, 23]);

     console.log("Awaited fourth, calling fifth");

     let rez5 = await callAction5([22, 23]);

     console.log("finally fifth!!");

        console.log("Izvrseno sve!");


    }

    const handleListButton = (data) => {

        console.log("Data gotten");
        console.log(data);
        // Log checked checkboxes and the data object associated with the clicked list item
        console.log('Checked Checkboxes for Data ID:', data.id, checkedCheckboxes[data.id]);

        console.log(checkedCheckboxes[data.id]);
        console.log(data);


        let tmpArr = [];

        console.log("Starting tmpArr: ");
        console.log(tmpArr);

       if(checkedCheckboxes[data.id]){

            if(checkedCheckboxes[data.id] && checkedCheckboxes[data.id].vipnet && checkedCheckboxes[data.id].vipnet==true){
                    

                tkListA1.forEach((item)=>{

                    tmpArr.push(item);
                })

                console.log("TmpArr a1: ");
                console.log(tmpArr);
            }
            if(checkedCheckboxes[data.id] && checkedCheckboxes[data.id].ostaliFiks && checkedCheckboxes[data.id].ostaliFiks==true){
                
                tkListOstali.forEach((item)=>{

                    tmpArr.push(item);
                })

                console.log("TmpArr ostali: ");
                console.log(tmpArr);
            }
            if(checkedCheckboxes[data.id] && checkedCheckboxes[data.id].tele2 && checkedCheckboxes[data.id].tele2==true){
                
                tkListTele.forEach((item)=>{

                    tmpArr.push(item);
                })

                console.log("TmpArr tele: ");
                console.log(tmpArr);
            }
            if(checkedCheckboxes[data.id] && checkedCheckboxes[data.id].tMobile && checkedCheckboxes[data.id].tMobile==true){

                tkListTMob.forEach((item)=>{

                    tmpArr.push(item);
                })

                console.log("TmpArr tmob: ");
                console.log(tmpArr);
            }
            if(checkedCheckboxes[data.id] && checkedCheckboxes[data.id].donat && checkedCheckboxes[data.id].donat==true){

                tkListDonat.forEach((item)=>{

                    tmpArr.push(item);
                })

                console.log("TmpArr donat: ");
                console.log(tmpArr);
            }

           
            
       

        console.log("Final tmpArr: ");
        console.log(tmpArr)


        if(data.id == 1){

                if(tmpArr && tmpArr.length !=0){
                        
                    callAction12(tmpArr);

                } else {

                    toast.warning("Morate odabrati barem jednog operatera za izvršiti akciju", toastInfo);
                }

        } else if(data.id == 2){

            if(tmpArr && tmpArr.length !=0){
                        
                callAction22(tmpArr);

            } else {

                toast.warning("Morate odabrati barem jednog operatera za izvršiti akciju", toastInfo);
            }
        } else if(data.id == 3){

            if(tmpArr && tmpArr.length !=0){
                        
                callAction32(tmpArr);

            } else {

                toast.warning("Morate odabrati barem jednog operatera za izvršiti akciju", toastInfo);
            }

        } else if(data.id == 4){

            if(tmpArr && tmpArr.length !=0){
                        
                callAction42(tmpArr);

            } else {

                toast.warning("Morate odabrati barem jednog operatera za izvršiti akciju", toastInfo);
            }

        } else if(data.id == 5){

            if(tmpArr && tmpArr.length !=0){
                        
                callAction52(tmpArr);

            } else {

                toast.warning("Morate odabrati barem jednog operatera za izvršiti akciju", toastInfo);
            }
        } else {

            if(tmpArr && tmpArr.length !=0){
                        
                callAction62(tmpArr);

            } else {

                toast.warning("Morate odabrati barem jednog operatera za izvršiti akciju", toastInfo);
            }
        }

    } else {

            toast.warning("Morate odabrati barem jednog operatera za izvršiti akciju", toastInfo);

    }


    };



    async function callAction1(tmpArr) {

        console.log(tmpArr)
    if(tmpArr.includes(33)){

        console.log("Donat!!!")
   
        return APICall(
            '/filter1_Donat_zadnje',
            {
                 referent: ref,
                 refName: username,
                 tkID: tmpArr,
                 platform: '0',
                 version:'1.0'
             }, {
                 token
             });

 


    } else {
       
        return APICall(
            '/filter1_svi_zadnje',
            {
                 referent: ref,
                 refName: username,
                 tkID: tmpArr,
                 platform: '0',
                 version:'1.0'
             }, {
                 token
             });

        }
            
    }



    async function callAction2(tmpArr) {


        console.log(tmpArr);

        if(tmpArr[0]==33){

            return APICall(
                '/filter2_Donat_zadnje',
                {
                 referent: ref,
                 refName: username,
                     tkID: tmpArr,
                     platform: '0',
                     version:'1.0'
                 }, {
                     token
                 })
                 
                 /*.then((response)=> {
                     
                     console.log(response.status)
     
                     
     
                  
                     if(response.status==200) {
                         console.log(response.status, response.data);
     
                         
                     }
                     else if(response.status==401) {
     
                         console.log("Istekla sesija");
     
                         setLoading(false);
     
                         toast.error(response.data.message, toastError);
     
     
                     
                        setTimeout(() => {
                                 dispatch(actions.logOut());
                                 navigate('/');
                        }, 5000);                                       
                         
     
     
                     } else{
     
                             //toast.error(response.data.message, toastError);
     
                     }      
                 },
                 (error) => {
         
     
                         setLoading(false);
              
                          if(!error.response){
     
                              // toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                              //      toastError);
                            
     
     
                          } else {
     
     
                               if(!error.response.status){
     
                                  //  toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                  //  toastError);
     
                               }else{
     
                                    if (error.response.status == 401) {
                
                                         
                                         toast.error(error.response.data.message,
                                              toastError);
                                                              
                             
     
                     
                                         setTimeout(() => {
                                                 dispatch(actions.logOut());
                                                 navigate('/');
                                         }, 5000);                                       
                                         
                                    
                               
                                    } else {
                               
                               
                                          //    toast.error(error.response.data.message,
                                          //         toastError);
                                                                             
                                         
                                    }
                               }
                          }
                      
                     
              
              
              });
              */


        } else{

       


        
       return APICall(
           '/filter2_svi_zadnje',
           {
            referent: ref,
            refName: username,
                tkID: tmpArr,
                platform: '0',
                version:'1.0'
            }, {
                token
            })
            
            /*.then((response)=> {
                
                console.log(response.status)

                

             
                if(response.status==200) {
                    console.log(response.status, response.data);

                    
                }
                else if(response.status==401) {

                    console.log("Istekla sesija");

                    setLoading(false);

                    toast.error(response.data.message, toastError);


                
                   setTimeout(() => {
                            dispatch(actions.logOut());
                            navigate('/');
                   }, 5000);                                       
                    


                } else{

                        //toast.error(response.data.message, toastError);

                }      
            },
            (error) => {
    

                    setLoading(false);
         
                     if(!error.response){

                         // toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                         //      toastError);
                       


                     } else {


                          if(!error.response.status){

                             //  toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                             //  toastError);

                          }else{

                               if (error.response.status == 401) {
           
                                    
                                    toast.error(error.response.data.message,
                                         toastError);
                                                         
                        

                
                                    setTimeout(() => {
                                            dispatch(actions.logOut());
                                            navigate('/');
                                    }, 5000);                                       
                                    
                               
                          
                               } else {
                          
                          
                                     //    toast.error(error.response.data.message,
                                     //         toastError);
                                                                        
                                    
                               }
                          }
                     }
                 
                
         
         
         }); */

        }
            
    }



    async function callAction3(tmpArr) {


     if(tmpArr[0]==33){
 

        return APICall(
            '/filter3_Donat_zadnje',
            {
             referent: ref,
             refName: username,
                 tkID: tmpArr,
                 platform: '0',
                 version:'1.0'
             }, {
                 token
             })
             


    }else {
       return APICall(
           '/filter3_svi_zadnje',
           {
            referent: ref,
            refName: username,
                tkID: tmpArr,
                platform: '0',
                version:'1.0'
            }, {
                token
            })
            
         
        }       
    }



    async function callAction4(tmpArr) {






     if(tmpArr[0]==33){
 

        return APICall(
            '/filter6_Donat_zadnje',
            {
             referent: ref,
             refName: username,
                 tkID: tmpArr,
                 platform: '0',
                 version:'1.0'
             }, {
                 token
             })
             /*.then((response)=> {
                 
                 console.log(response.status)

                 return(1)
 
 
 
 
                 //dispatch(actions.isNotLoading());
                 //console.log("aaaaaaaaaaaaaaaaaaa")
                 //toast.success("Sve akcije su uspješno izvršene", toastSuccess);
 
                 callAction5();
 
                 
 
             },
             (error) => {
     
 
                      setLoading(false);

          
                      if(!error.response){
 
                           //toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                           //     toastError);
                        
 
                           //callAction5();

                           return(1)
 
                      } else {
 
 
                           if(!error.response.status){
 
                                //toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                //toastError);
 
                                //callAction5();

                                return(1)
 
                           }else{
 
                                if (error.response.status == 401) {
            
                                     
                                     toast.error(error.response.data.message,
                                          toastError);
                                                          
                         
 
                 
                                     setTimeout(() => {
                                             dispatch(actions.logOut());
                                             navigate('/');
                                     }, 5000);                                       
                                     
                                    
                           
                                } else {
                           
                                         //callAction5();

                                         return(1)
                           
                                        //  toast.error(error.response.data.message,
                                        //       toastError);
                                                                         
                                     
                                }
                           }
                      }
                  
                 
          
          
          });*/


    }else {
       return APICall(
           '/filter6_svi_zadnje',
           {
            referent: ref,
            refName: username,
                tkID: tmpArr,
                platform: '0',
                version:'1.0'
            }, {
                token
            })
            /*.then((response)=> {
                
                console.log(response.status)




                //dispatch(actions.isNotLoading());
                //console.log("aaaaaaaaaaaaaaaaaaa")
                //toast.success("Sve akcije su uspješno izvršene", toastSuccess);

                //callAction5();

                return(1)

                

            },
            (error) => {
    

                     setLoading(false);
         
                     if(!error.response){

                          //toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                          //     toastError);
                       

                          //callAction5();

                          return(1)

                     } else {


                          if(!error.response.status){

                               //toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                               //toastError);

                               //callAction5();

                               return(1)

                          }else{

                               if (error.response.status == 401) {
           
                                    
                                    toast.error(error.response.data.message,
                                         toastError);
                                                         
                        

                
                                    setTimeout(() => {
                                            dispatch(actions.logOut());
                                            navigate('/');
                                    }, 5000);  
                                    
                                    
                               
                          
                               } else {
                          
                                        //callAction4();

                                        return(1)
                          
                                       //  toast.error(error.response.data.message,
                                       //       toastError);
                                                                        
                                    
                               }
                          }
                     }
                 
                
         
         
         }); */
         
        }       
            
    }


    async function callActionDel(tmpArr) {


     if(tmpArr[0]==33){
 

        return APICall(
            '/filter5_Donat_zadnje',
            {
             referent: ref,
             refName: username,
                 tkID: tmpArr,
                 platform: '0',
                 version:'1.0'
             }, {
                 token
             })
             


    }else {
       return APICall(
           '/filter5_Svi_zadnje',
           {
            referent: ref,
            refName: username,
                tkID: tmpArr,
                platform: '0',
                version:'1.0'
            }, {
                token
            })
            
         
        }       
    }


    async function callAction5() {


        setTimeout(() => {
            dispatch(actions.isNotLoading());
            toast.success("Sve akcije su uspješno izvršene", toastSuccess);

            setTimeout(()=>{


                getDoneFilters();

            }, 5000)

            
        }, 10);    
            
    }



    async function callAction6(tmpArr) {



        console.log("Action1");
        //samo me prijavi

        setLoading(true);

        
       APICall(
           '/getNumberAction6',
           {
            referent: ref,
            refName: username,
                tkID: tmpArr,
                platform: '0',
                version:'1.0'
            }, {
                token
            }).then((response)=> {
                
                console.log(response.status)

                /*

                setLoading(false);

             
                if(response.status==200) {
                    console.log(response.status, response.data);

                    let count = response.data.countA + response.data.countB;

                    if(count == 0){

                        toast.success("Nema podataka koji zadovoljavaju traženi kriterij, izmjene nisu potrebne", toastSuccess);


                    } else {

                        let msg = "Za arhiviranje ima: " + response.data.countA + " + " + response.data.countB + " slogova praznih promjena ili prelazaka na fizičke osobe. ";


                        msg = msg + "Želite li pokrenuti izmjene?"

                        if (window.confirm(msg)) {
                            // Save it!
                            console.log('Thing was saved to the database.');

                            obrisiAction6(tmpArr);

                          } else {
                            // Do nothing!
                            console.log('Thing was not saved to the database.');
                          }

                    }

                    

                    
                }
                else if(response.status==401) {

                    console.log("Istekla sesija");

                    toast.error(response.data.message, toastError);


                
                   setTimeout(() => {
                            dispatch(actions.logOut());
                            navigate('/');
                   }, 5000);                                       
                    


                } else{

                        toast.error(response.data.message, toastError);

                }      

                */
            },
            (error) => {
    

                setLoading(false);
         
                     if(!error.response){

                          //toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                          //     toastError);
                       


                     } else {


                          if(!error.response.status){

                              // toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                              // toastError);

                          }else{

                               if (error.response.status == 401) {
           
                                    
                                    toast.error(error.response.data.message,
                                         toastError);
                                                         
                        

                
                                    setTimeout(() => {
                                            dispatch(actions.logOut());
                                            navigate('/');
                                    }, 5000);                                       
                                    
                               
                          
                               } else {
                          
                          
                                     //    toast.error(error.response.data.message,
                                     //         toastError);
                                                                        
                                    
                               }
                          }
                     }
                 
                
         
         
         });
            
    }


    async function obrisiAction6(tmpArr) {



        console.log("Obrisi action1");
        //samo me prijavi

        setLoading(true);

        
       APICall(
           '/obrisiAction6',
           {
                referent: 1,
                tkID: tmpArr,
                platform: '0',
                version:'1.0'
            }, {
                token
            }).then((response)=> {
                
                console.log(response.status)

                setLoading(false);

             
                if(response.status==200) {
                    console.log(response.status, response.data[0]);

                    toast.success(response.data.msg);
                }
                else if(response.status==401) {

                    console.log("Istekla sesija");

                    toast.error(response.data.message, toastError);


                
                   setTimeout(() => {
                            dispatch(actions.logOut());
                            navigate('/');
                   }, 5000);                                       
                    


                } else{

                        toast.error(response.data.message, toastError);

                }      
            },
            (error) => {
    
                setLoading(false);

         
         
                     if(!error.response){

                          toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                               toastError);
                       


                     } else {


                          if(!error.response.status){

                               toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                               toastError);

                          }else{

                               if (error.response.status == 401) {
           
                                    
                                    toast.error(error.response.data.message,
                                         toastError);
                                                         
                        

                
                                    setTimeout(() => {
                                            dispatch(actions.logOut());
                                            navigate('/');
                                    }, 5000);                                       
                                    
                               
                          
                               } else {
                          
                          
                                         toast.error(error.response.data.message,
                                              toastError);
                                                                        
                                    
                               }
                          }
                     }
                 
                
         
         
         });
            
    }


    async function callAction12(tmpArr) {


        setLoading(true);

        console.log("Action1");
        //samo me prijavi

        
       APICall(
           '/getNumberAction1',
           {
                referent: 1,
                tkID: tmpArr,
                platform: '0',
                version:'1.0'
            }, {
                token
            }).then((response)=> {
                
                console.log(response.status)

                setLoading(false);

             
                if(response.status==200) {
                    console.log(response.status, response.data);

                    if(response.data.count == 0){

                        toast.success("Nema podataka koji zadovoljavaju traženi kriterij, izmjene nisu potrebne", toastSuccess);

                    } else {

                        let msg = "Broj promjena koje će se izvršiti je: " + response.data.count;

                        msg = msg + ". Želite li pokrenuti izmjene?"

                        if (window.confirm(msg)) {
                            // Save it!
                            console.log('Thing was saved to the database.');

                            obrisiAction12(tmpArr);

                          } else {
                            // Do nothing!
                            console.log('Thing was not saved to the database.');
                          }

                    }

                    

                    
                }
                else if(response.status==401) {

                    console.log("Istekla sesija");

                    toast.error(response.data.message, toastError);


                
                   setTimeout(() => {
                            dispatch(actions.logOut());
                            navigate('/');
                   }, 5000);                                       
                    


                } else{

                        toast.error(response.data.message, toastError);

                }      
            },
            (error) => {
    

                    setLoading(false);
         
                     if(!error.response){

                          toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                               toastError);
                       


                     } else {


                          if(!error.response.status){

                               toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                               toastError);

                          }else{

                               if (error.response.status == 401) {
           
                                    
                                    toast.error(error.response.data.message,
                                         toastError);
                                                         
                        

                
                                    setTimeout(() => {
                                            dispatch(actions.logOut());
                                            navigate('/');
                                    }, 5000);                                       
                                    
                               
                          
                               } else {
                          
                          
                                         toast.error(error.response.data.message,
                                              toastError);
                                                                        
                                    
                               }
                          }
                     }
                 
                
         
         
         });
            
    }


    async function obrisiAction12(tmpArr) {



        console.log("Obrisi action1");
        //samo me prijavi

        setLoading(true);

        
       APICall(
           '/obrisiAction1',
           {
                referent: 1,
                tkID: tmpArr,
                platform: '0',
                version:'1.0'
            }, {
                token
            }).then((response)=> {
                
                console.log(response.status)

                setLoading(false);

             
                if(response.status==200) {
                    console.log(response.status, response.data[0]);

                    //toast.success(response.data.msg);
                }
                else if(response.status==401) {

                    console.log("Istekla sesija");

                    toast.error(response.data.message, toastError);


                
                   setTimeout(() => {
                            dispatch(actions.logOut());
                            navigate('/');
                   }, 5000);                                       
                    


                } else{

                     //   toast.error(response.data.message, toastError);

                }      
            },
            (error) => {
    

                    setLoading(false);
         
                     if(!error.response){

                         // toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                         //      toastError);
                       


                     } else {


                          if(!error.response.status){

                              // toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                              // toastError);

                          }else{

                               if (error.response.status == 401) {
           
                                    
                                    toast.error(error.response.data.message,
                                         toastError);
                                                         
                        

                
                                    setTimeout(() => {
                                            dispatch(actions.logOut());
                                            navigate('/');
                                    }, 5000);                                       
                                    
                               
                          
                               } else {
                          
                          
                                      //   toast.error(error.response.data.message,
                                      //        toastError);
                                                                        
                                    
                               }
                          }
                     }
                 
                
         
         
         });
            
    }

    async function callAction22(tmpArr) {



        //samo me prijavi

        setLoading(true);

        //dispatch(actions.isLoading());

        
       APICall(
           '/getNumberAction2',
           {
                referent: 1,
                tkID: tmpArr,
                platform: '0',
                version:'1.0'
            }, {
                token
            }).then((response)=> {
                
                console.log(response.status)

                setLoading(false);

             
                if(response.status==200) {
                    console.log(response.status, response.data);

                    if(response.data.countE == 0){

                        toast.success("Nema podataka koji zadovoljavaju traženi kriterij, izmjene nisu potrebne", toastSuccess);

                    } else {

                        let countA = 0;
                        let countB = 0;
                        let countC = 0;
                        let countE = 0;

                        countA = response.data.countA;
                        countC = response.data.countC;
                        countE = response.data.countE;


                        let msg = "Traženih redaka u spisku: " + response.data.countA + ". ";

                        msg = msg + "U njima je traženih telefona " + countC + ", a primjenjuju se na " + countE + " slogova strukture bijelih. "



                        msg = msg + "Želite li pokrenuti izmjene?"

                        if (window.confirm(msg)) {
                            // Save it!
                            console.log('Thing was saved to the database.');

                            //obrisiAction2(tmpArr);

                            toast.error("Nije uspjelo filtriranje spiskova, izgubljena komunikacija sa serverom", toastError);

                          } else {
                            // Do nothing!
                            console.log('Thing was not saved to the database.');
                          }

                    }

                    

                    
                }
                else if(response.status==401) {

                    console.log("Istekla sesija");

                    toast.error(response.data.message, toastError);


                
                   setTimeout(() => {
                            dispatch(actions.logOut());
                            navigate('/');
                   }, 5000);                                       
                    


                } else{

                        toast.error(response.data.message, toastError);

                }      
            },
            (error) => {
    

                    setLoading(false);
         
                     if(!error.response){

                          toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                               toastError);
                       


                     } else {


                          if(!error.response.status){

                               toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                               toastError);

                          }else{

                               if (error.response.status == 401) {
           
                                    
                                    toast.error(error.response.data.message,
                                         toastError);
                                                         
                        

                
                                    setTimeout(() => {
                                            dispatch(actions.logOut());
                                            navigate('/');
                                    }, 5000);                                       
                                    
                               
                          
                               } else {
                          
                          
                                         toast.error(error.response.data.message,
                                              toastError);
                                                                        
                                    
                               }
                          }
                     }
                 
                
         
         
         });
            
    }


    async function obrisiAction22(tmpArr) {



        console.log("Obrisi action1");
        //samo me prijavi

        setLoading(true);

        
       APICall(
           '/obrisiAction1',
           {
                referent: 1,
                tkID: tmpArr,
                platform: '0',
                version:'1.0'
            }, {
                token
            }).then((response)=> {
                
                console.log(response.status)

                setLoading(false);

             
                if(response.status==200) {
                    console.log(response.status, response.data[0]);

                    toast.success(response.data.msg);
                }
                else if(response.status==401) {

                    console.log("Istekla sesija");

                    toast.error(response.data.message, toastError);


                
                   setTimeout(() => {
                            dispatch(actions.logOut());
                            navigate('/');
                   }, 5000);                                       
                    


                } else{

                        toast.error(response.data.message, toastError);

                }      
            },
            (error) => {
    

                    setLoading(false);
         
                     if(!error.response){

                          toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                               toastError);
                       


                     } else {


                          if(!error.response.status){

                               toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                               toastError);

                          }else{

                               if (error.response.status == 401) {
           
                                    
                                    toast.error(error.response.data.message,
                                         toastError);
                                                         
                        

                
                                    setTimeout(() => {
                                            dispatch(actions.logOut());
                                            navigate('/');
                                    }, 5000);                                       
                                    
                               
                          
                               } else {
                          
                          
                                         toast.error(error.response.data.message,
                                              toastError);
                                                                        
                                    
                               }
                          }
                     }
                 
                
         
         
         });
            
    }

    async function callAction32(tmpArr) {



        console.log("Action1");
        //samo me prijavi

        setLoading(true);

        
       APICall(
           '/getNumberAction3',
           {
                referent: 1,
                tkID: tmpArr,
                platform: '0',
                version:'1.0'
            }, {
                token
            }).then((response)=> {
                
                console.log(response.status)

                setLoading(false);

             
                if(response.status==200) {
                    console.log(response.status, response.data);

                    if(response.data.count == 0){

                        toast.success("Nema podataka koji zadovoljavaju traženi kriterij, izmjene nisu potrebne", toastSuccess);

                    } else {

                        let msg = "Broj promjena koje će se izvršiti je: " + response.data.count;

                        msg = msg + ". Želite li pokrenuti izmjene?"

                        if (window.confirm(msg)) {
                            // Save it!
                            console.log('Thing was saved to the database.');

                            obrisiAction32(tmpArr);

                          } else {
                            // Do nothing!
                            console.log('Thing was not saved to the database.');
                          }

                    }

                    

                    
                }
                else if(response.status==401) {

                    console.log("Istekla sesija");

                    toast.error(response.data.message, toastError);


                
                   setTimeout(() => {
                            dispatch(actions.logOut());
                            navigate('/');
                   }, 5000);                                       
                    


                } else{

                        toast.error(response.data.message, toastError);

                }      
            },
            (error) => {
    

                        setLoading(false);
         
                     if(!error.response){

                          toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                               toastError);
                       


                     } else {


                          if(!error.response.status){

                               toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                               toastError);

                          }else{

                               if (error.response.status == 401) {
           
                                    
                                    toast.error(error.response.data.message,
                                         toastError);
                                                         
                        

                
                                    setTimeout(() => {
                                            dispatch(actions.logOut());
                                            navigate('/');
                                    }, 5000);                                       
                                    
                               
                          
                               } else {
                          
                          
                                         toast.error(error.response.data.message,
                                              toastError);
                                                                        
                                    
                               }
                          }
                     }
                 
                
         
         
         });
            
    }


    async function obrisiAction32(tmpArr) {



        console.log("Obrisi action1");
        //samo me prijavi
        setLoading(true);

        
       APICall(
           '/obrisiAction3',
           {
                referent: 1,
                tkID: tmpArr,
                platform: '0',
                version:'1.0'
            }, {
                token
            }).then((response)=> {
                
                console.log(response.status)

                setLoading(false);

             
                if(response.status==200) {
                    console.log(response.status, response.data[0]);

                    toast.success(response.data.msg);
                }
                else if(response.status==401) {

                    console.log("Istekla sesija");

                    toast.error(response.data.message, toastError);


                
                   setTimeout(() => {
                            dispatch(actions.logOut());
                            navigate('/');
                   }, 5000);                                       
                    


                } else{

                        toast.error(response.data.message, toastError);

                }      
            },
            (error) => {

                setLoading(false);
    

         
         
                     if(!error.response){

                          toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                               toastError);
                       


                     } else {


                          if(!error.response.status){

                               toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                               toastError);

                          }else{

                               if (error.response.status == 401) {
           
                                    
                                    toast.error(error.response.data.message,
                                         toastError);
                                                         
                        

                
                                    setTimeout(() => {
                                            dispatch(actions.logOut());
                                            navigate('/');
                                    }, 5000);                                       
                                    
                               
                          
                               } else {
                          
                          
                                         toast.error(error.response.data.message,
                                              toastError);
                                                                        
                                    
                               }
                          }
                     }
                 
                
         
         
         });
            
    }

    async function callAction42(tmpArr) {



        console.log("Action1");
        //samo me prijavi

        
       APICall(
           '/getNumberAction1',
           {
                referent: 1,
                tkID: tmpArr,
                platform: '0',
                version:'1.0'
            }, {
                token
            }).then((response)=> {
                
                console.log(response.status)

             
                if(response.status==200) {
                    console.log(response.status, response.data);

                    if(response.data.count == 0){

                        toast.success("Nema podataka koji zadovoljavaju traženi kriterij, izmjene nisu potrebne", toastSuccess);

                    } else {

                        let msg = "Broj promjena koje će se izvršiti je: " + response.data.count;

                        msg = msg + ". Želite li pokrenuti izmjene?"

                        if (window.confirm(msg)) {
                            // Save it!
                            console.log('Thing was saved to the database.');

                            obrisiAction12(tmpArr);

                          } else {
                            // Do nothing!
                            console.log('Thing was not saved to the database.');
                          }

                    }

                    

                    
                }
                else if(response.status==401) {

                    console.log("Istekla sesija");

                    toast.error(response.data.message, toastError);


                
                   setTimeout(() => {
                            dispatch(actions.logOut());
                            navigate('/');
                   }, 5000);                                       
                    


                } else{

                        toast.error(response.data.message, toastError);

                }      
            },
            (error) => {
    

         
         
                     if(!error.response){

                          toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                               toastError);
                       


                     } else {


                          if(!error.response.status){

                               toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                               toastError);

                          }else{

                               if (error.response.status == 401) {
           
                                    
                                    toast.error(error.response.data.message,
                                         toastError);
                                                         
                        

                
                                    setTimeout(() => {
                                            dispatch(actions.logOut());
                                            navigate('/');
                                    }, 5000);                                       
                                    
                               
                          
                               } else {
                          
                          
                                         toast.error(error.response.data.message,
                                              toastError);
                                                                        
                                    
                               }
                          }
                     }
                 
                
         
         
         });
            
    }


    async function obrisiAction42(tmpArr) {



        console.log("Obrisi action1");
        //samo me prijavi

        
       APICall(
           '/obrisiAction1',
           {
                referent: 1,
                tkID: tmpArr,
                platform: '0',
                version:'1.0'
            }, {
                token
            }).then((response)=> {
                
                console.log(response.status)

             
                if(response.status==200) {
                    console.log(response.status, response.data[0]);

                    toast.success(response.data.msg);
                }
                else if(response.status==401) {

                    console.log("Istekla sesija");

                    toast.error(response.data.message, toastError);


                
                   setTimeout(() => {
                            dispatch(actions.logOut());
                            navigate('/');
                   }, 5000);                                       
                    


                } else{

                        toast.error(response.data.message, toastError);

                }      
            },
            (error) => {
    

         
         
                     if(!error.response){

                          toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                               toastError);
                       


                     } else {


                          if(!error.response.status){

                               toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                               toastError);

                          }else{

                               if (error.response.status == 401) {
           
                                    
                                    toast.error(error.response.data.message,
                                         toastError);
                                                         
                        

                
                                    setTimeout(() => {
                                            dispatch(actions.logOut());
                                            navigate('/');
                                    }, 5000);                                       
                                    
                               
                          
                               } else {
                          
                          
                                         toast.error(error.response.data.message,
                                              toastError);
                                                                        
                                    
                               }
                          }
                     }
                 
                
         
         
         });
            
    }


    async function callAction52(tmpArr) {



        console.log("Action1");
        //samo me prijavi

        setLoading(true);

        

        
       APICall(
           '/getNumberAction5',
           {
                referent: 1,
                tkID: tmpArr,
                platform: '0',
                version:'1.0'
            }, {
                token
            }).then((response)=> {
                
                console.log(response.status)

                setLoading(false);

             
                if(response.status==200) {
                    console.log(response.status, response.data);

                    if(response.data.count == 0){

                        toast.success("Nema podataka koji zadovoljavaju traženi kriterij, izmjene nisu potrebne", toastSuccess);

                    } else {

                        let msg = "Broj promjena koje će se izvršiti je: " + response.data.count;

                        msg = msg + ". Želite li pokrenuti izmjene?"

                        if (window.confirm(msg)) {
                            // Save it!
                            console.log('Thing was saved to the database.');

                            obrisiAction52(tmpArr);

                          } else {
                            // Do nothing!
                            console.log('Thing was not saved to the database.');
                          }

                    }

                    

                    
                }
                else if(response.status==401) {

                    console.log("Istekla sesija");

                    toast.error(response.data.message, toastError);


                
                   setTimeout(() => {
                            dispatch(actions.logOut());
                            navigate('/');
                   }, 5000);                                       
                    


                } else{

                        toast.error(response.data.message, toastError);

                }      
            },
            (error) => {
    

         
                setLoading(false);
         
                     if(!error.response){

                          toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                               toastError);
                       


                     } else {


                          if(!error.response.status){

                               toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                               toastError);

                          }else{

                               if (error.response.status == 401) {
           
                                    
                                    toast.error(error.response.data.message,
                                         toastError);
                                                         
                        

                
                                    setTimeout(() => {
                                            dispatch(actions.logOut());
                                            navigate('/');
                                    }, 5000);                                       
                                    
                               
                          
                               } else {
                          
                          
                                         toast.error(error.response.data.message,
                                              toastError);
                                                                        
                                    
                               }
                          }
                     }
                 
                
         
         
         });
            
    }


    async function obrisiAction52(tmpArr) {



        console.log("Obrisi action1");
        //samo me prijavi

        setLoading(true);

        
       APICall(
           '/obrisiAction5',
           {
                referent: 1,
                tkID: tmpArr,
                platform: '0',
                version:'1.0'
            }, {
                token
            }).then((response)=> {
                
                console.log(response.status)

                setLoading(false);

             
                if(response.status==200) {
                    console.log(response.status, response.data[0]);

                    toast.success(response.data.msg);
                }
                else if(response.status==401) {

                    console.log("Istekla sesija");

                    toast.error(response.data.message, toastError);


                
                   setTimeout(() => {
                            dispatch(actions.logOut());
                            navigate('/');
                   }, 5000);                                       
                    


                } else{

                        toast.error(response.data.message, toastError);

                }      
            },
            (error) => {
    

                setLoading(false);
         
         
                     if(!error.response){

                          toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                               toastError);
                       


                     } else {


                          if(!error.response.status){

                               toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                               toastError);

                          }else{

                               if (error.response.status == 401) {
           
                                    
                                    toast.error(error.response.data.message,
                                         toastError);
                                                         
                        

                
                                    setTimeout(() => {
                                            dispatch(actions.logOut());
                                            navigate('/');
                                    }, 5000);                                       
                                    
                               
                          
                               } else {
                          
                          
                                         toast.error(error.response.data.message,
                                              toastError);
                                                                        
                                    
                               }
                          }
                     }
                 
                
         
         
         });
            
    }


    async function callAction62(tmpArr) {



        console.log("Action1");
        //samo me prijavi

        setLoading(true);

        
       APICall(
           '/getNumberAction6',
           {
                referent: 1,
                tkID: tmpArr,
                platform: '0',
                version:'1.0'
            }, {
                token
            }).then((response)=> {
                
                console.log(response.status)

                setLoading(false);

             
                if(response.status==200) {
                    console.log(response.status, response.data);

                    let count = response.data.countA + response.data.countB;

                    if(count == 0){

                        toast.success("Nema podataka koji zadovoljavaju traženi kriterij, izmjene nisu potrebne", toastSuccess);


                    } else {

                        let msg = "Za arhiviranje ima: " + response.data.countA + " + " + response.data.countB + " slogova praznih promjena ili prelazaka na fizičke osobe. ";


                        msg = msg + "Želite li pokrenuti izmjene?"

                        if (window.confirm(msg)) {
                            // Save it!
                            console.log('Thing was saved to the database.');

                            obrisiAction62(tmpArr);

                          } else {
                            // Do nothing!
                            console.log('Thing was not saved to the database.');
                          }

                    }

                    

                    
                }
                else if(response.status==401) {

                    console.log("Istekla sesija");

                    toast.error(response.data.message, toastError);


                
                   setTimeout(() => {
                            dispatch(actions.logOut());
                            navigate('/');
                   }, 5000);                                       
                    


                } else{

                        toast.error(response.data.message, toastError);

                }      
            },
            (error) => {
    

                setLoading(false);
         
                     if(!error.response){

                          toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                               toastError);
                       


                     } else {


                          if(!error.response.status){

                               toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                               toastError);

                          }else{

                               if (error.response.status == 401) {
           
                                    
                                    toast.error(error.response.data.message,
                                         toastError);
                                                         
                        

                
                                    setTimeout(() => {
                                            dispatch(actions.logOut());
                                            navigate('/');
                                    }, 5000);                                       
                                    
                               
                          
                               } else {
                          
                          
                                         toast.error(error.response.data.message,
                                              toastError);
                                                                        
                                    
                               }
                          }
                     }
                 
                
         
         
         });
            
    }


    async function obrisiAction62(tmpArr) {



        console.log("Obrisi action1");
        //samo me prijavi

        setLoading(true);

        
       APICall(
           '/obrisiAction6',
           {
                referent: 1,
                tkID: tmpArr,
                platform: '0',
                version:'1.0'
            }, {
                token
            }).then((response)=> {
                
                console.log(response.status)

                setLoading(false);

             
                if(response.status==200) {
                    console.log(response.status, response.data[0]);

                    toast.success(response.data.msg);
                }
                else if(response.status==401) {

                    console.log("Istekla sesija");

                    toast.error(response.data.message, toastError);


                
                   setTimeout(() => {
                            dispatch(actions.logOut());
                            navigate('/');
                   }, 5000);                                       
                    


                } else{

                        toast.error(response.data.message, toastError);

                }      
            },
            (error) => {
    
                setLoading(false);

         
         
                     if(!error.response){

                          toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                               toastError);
                       


                     } else {


                          if(!error.response.status){

                               toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                               toastError);

                          }else{

                               if (error.response.status == 401) {
           
                                    
                                    toast.error(error.response.data.message,
                                         toastError);
                                                         
                        

                
                                    setTimeout(() => {
                                            dispatch(actions.logOut());
                                            navigate('/');
                                    }, 5000);                                       
                                    
                               
                          
                               } else {
                          
                          
                                         toast.error(error.response.data.message,
                                              toastError);
                                                                        
                                    
                               }
                          }
                     }
                 
                
         
         
         });
            
    }


    const PocetniScreenKomponenta = () => {
        return (
            <div className={styles.container}>

                    <div className="loader-container loader-container-automodal" style={{visibility:isLoading ? "visible" : "hidden"}}>
                        <Loader3 />
                    </div>


                <div className={styles.cardContainer}>
                    {/*Prvi red*/}
                    <div className={styles.redContainerDiv}>
                        <div style={{
                            width: '100%',
                           
                            maxHeight: '90vh',  padding:"0px"// Adjust the max height if needed
                        }}>
                            <div style={{display:'flex', flexDirection:'row', justifyContent:'flex-end'}}>
                            <Fab variant="extended" color="secondary"
                                onClick={() => {
                                                
                                        trenutnoStanjeSpiskovaButtonFunction()
                                    }}
                            >
                
                                    Trenutno stanje spiskova
                            </Fab>     
                            </div>                       
                            <List style={{ width: '100%' }}>
                                <ListItem sx={{padding:"0px"}}>
                                <div className={styles.buttonsCard}>
                                    <div style={{  display: 'flex', justifyContent: 'center', gap:'10px', alignItems: 'flex-start', gap:'10px', flexWrap:'wrap', width:'16.667%', flexDirection: 'column' }}>
                                            <Button 
                                    sx={{width:"110px", height:"30px", fontSize:"12px"}}
                                    fullWidth variant="contained"
                                                onClick={() => {
                                                

                                                    console.log("Calling all functions for Donat");

                                                    handleDonat();

                                                    
                                                }}
                                        >
                                        Donat
                                            </Button>
                                    </div>
                                    <div style={{  display: 'flex', justifyContent: 'center', gap:'10px', alignItems: 'flex-start', gap:'10px', flexWrap:'wrap', width:'16.667%', flexDirection: 'column' }}>
                                            <Button  sx={{width:"110px", height:"30px", fontSize:"12px"}} fullWidth variant="contained"
                                                onClick={() => {
                                                    /*mockData.map(item=> {

                                                        let firstCheckedBox= checkedCheckboxes["1"] ? checkedCheckboxes["1"].tMobile :false
                                                        setCheckedCheckboxes((prevChecked) => (
                                                             {
                                                           
                                                            ...prevChecked,
                                                            [item.id]: {
                                                                ...prevChecked[item.id],
                                                                ["tMobile"]: !firstCheckedBox,
                                                            },
                                                        }));

                                                        


                                                    })*/

                                                    handleTMobile();
                                                    
                                                }}
                                        >
                                        T-Mobile
                                            </Button>
                                    </div>
                                    <div style={{  display: 'flex', justifyContent: 'center', gap:'10px', alignItems: 'flex-start', gap:'10px', flexWrap:'wrap', width:'16.667%', flexDirection: 'column' }}>
                                            <Button sx={{width:"110px", height:"30px", fontSize:"12px"}}  fullWidth variant="contained"
                                                onClick={() => {
                                        

                                                        handleOstali();
                                                  
                                                    
                                                }}
                                        >
                                        Ostali fiks
                                            </Button>
                                    </div>
                                    <div style={{  display: 'flex', justifyContent: 'center', gap:'10px', alignItems: 'flex-start', gap:'10px', flexWrap:'wrap', width:'16.667%', flexDirection: 'column' }}>
                                            <Button sx={{width:"110px", height:"30px", fontSize:"12px"}}  fullWidth variant="contained"
                                                onClick={() => {
                                                  

                                                        handleTele();
                                              
                                                    
                                                }}
                                        >
                                        Telemach
                                            </Button>
                                    </div>
                                    <div style={{  display: 'flex', justifyContent: 'center', gap:'10px', alignItems: 'flex-start', gap:'10px', flexWrap:'wrap', width:'16.667%', flexDirection: 'column' }}>
                                            <Button sx={{width:"110px", height:"30px", fontSize:"12px"}} fullWidth variant="contained"
                                                onClick={() => {
                                                 

                                                        handleA1();
                                                  
                                                    
                                                }}
                                        >
                                        A1
                                            </Button>
                                    </div>


                                </div>

                                </ListItem>
                                {mockData.map((data) => (
                                    <ListItem sx={{padding:"0px" ,borderTop:"1px solid lightgrey"}} key={data.id}>
                                        <div style={{ display: 'flex', flexDirection: 'column', width: '100%', marginBottom: '0px', padding: '1px', borderRadius:"10px"}}>
                                            <div style={{ width: '100%' }}>
                                                <Typography variant="h6" style={{ fontWeight: 'bold', fontSize: '1rem', margin:"2px 0" }}>
                                                    {data.title}
                                                </Typography>
                                            </div>
                                            <div style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent:'space-between',alignItems:'flex-start' }}>

                                                <div style={{  display: 'flex', justifyContent: 'center', gap:'10px', alignItems: 'flex-start', justifyContent:"flex-start", gap:'10px', width:'16.667%', flexDirection: 'column' }}>
                                                    
                                                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap:'5px'  }}>
                                                      <Checkbox
                                                            sx={{padding:0}}
                                                            checked={checkedCheckboxes[data.id]?.donat || false}
                                                            onChange={() => handleCheckboxChange(data.id, 'donat')}
                                                        /> 
                                                        <label style={{fontSize:"15px"}}>Donat</label>
                                                    </div>
                                               

<div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'center', flexDirection:"column"}}>
                                                    {data.id==1 && donatLast_ak1 && donatLast_ak1!='' && donatLast_ak1.date && donatLast_ak1.date!='' 
                                                        && 
                                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', 
                                                            gap:'5px', lineBreak: 'anywhere', fontSize:'14px', overflow:"hidden", 
                                                            transition:"1s", height:showDetails=="show-data-"+data.id ? "0":"auto"}}>
                                                                <span style={{fontWeight:'bold', color:'red'}}>Datum:</span><br></br> {donatLast_ak1.date}</div>
                                                        }

                                                    {data.id==1 && donatLast_ak1 && donatLast_ak1!=''  
                                                        && 
                                                        <div  style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', 
                                                        gap:'5px', fontSize:'14px', overflow:"hidden", 
                                                        transition:"1s", height:showDetails=="show-data-"+data.id ? "0":"auto"}}><span style={{fontWeight:'bold', color:'red'}}>Količina:</span> {donatLast_ak1.num}</div>
                                                        }                

                                                    {data.id==4 && donatLast_ak1 && donatLast_ak1!='' && donatLast_ak1.date && donatLast_ak1.date!='' 
                                                        && 
                                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', 
                                                            gap:'5px', lineBreak: 'anywhere', fontSize:'14px', overflow:"hidden", 
                                                            transition:"1s", height:showDetails=="show-data-"+data.id ? "0":"auto"}}>
                                                                <span style={{fontWeight:'bold', color:'red'}}>Datum:</span><br></br> {donatLast_ak1.date}</div>
                                                        }

                                                    {data.id==4   
                                                        && 
                                                        <div  style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', 
                                                        gap:'5px', fontSize:'14px', overflow:"hidden", 
                                                        transition:"1s", height:showDetails=="show-data-"+data.id ? "0":"auto"}}><span style={{fontWeight:'bold', color:'red'}}>Količina:</span> 0</div>
                                                        }       


                                                    {data.id==5 && donatLast_ak5 && donatLast_ak5!='' && donatLast_ak5.date && donatLast_ak5.date!=''
                                                        && 
                                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', 
                                                            gap:'5px', lineBreak: 'anywhere', fontSize:'14px', overflow:"hidden", 
                                                            transition:"1s", height:showDetails=="show-data-"+data.id ? "0":"auto"}}>
                                                                <span style={{fontWeight:'bold', color:'red'}}>Datum:</span><br></br> {donatLast_ak5.date}</div>
                                                        }

                                                    {data.id==5   
                                                        && 
                                                        <div  style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', 
                                                        gap:'5px', fontSize:'14px', overflow:"hidden", 
                                                        transition:"1s", height:showDetails=="show-data-"+data.id ? "0":"auto"}}><span style={{fontWeight:'bold', color:'red'}}>Količina:</span> {donatLast_ak5.num}</div>
                                                        }       


                                                    {data.id==2 && donatLast_ak2 && donatLast_ak2!='' && donatLast_ak2.date && donatLast_ak2.date!=''
                                                        && 
                                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', 
                                                            gap:'5px', lineBreak: 'anywhere', fontSize:'14px', overflow:"hidden", 
                                                            transition:"1s", height:showDetails=="show-data-"+data.id ? "0":"auto"}}>
                                                                <span style={{fontWeight:'bold', color:'red'}}>Datum:</span><br></br> {donatLast_ak2.date}</div>
                                                        }

                                                    {data.id==2 && donatLast_ak2 && donatLast_ak2!=''   
                                                        && 
                                                        <div  style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', 
                                                        gap:'5px', fontSize:'14px', overflow:"hidden", 
                                                        transition:"1s", height:showDetails=="show-data-"+data.id ? "0":"auto"}}><span style={{fontWeight:'bold', color:'red'}}>Količina:</span> {donatLast_ak2.num}</div>
                                                        }                                                                                                                                   

                                                    {data.id==3 && donatLast_ak3 && donatLast_ak3!='' && donatLast_ak3.date && donatLast_ak3.date!=''
                                                        && 
                                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', 
                                                            gap:'5px', lineBreak: 'anywhere', fontSize:'14px', overflow:"hidden", 
                                                            transition:"1s", height:showDetails=="show-data-"+data.id ? "0":"auto"}}>
                                                                <span style={{fontWeight:'bold', color:'red'}}>Datum:</span><br></br> {donatLast_ak3.date}</div>
                                                        }

                                                    {data.id==3 && donatLast_ak3 && donatLast_ak3!=''   
                                                        && 
                                                        <div  style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', 
                                                        gap:'5px', fontSize:'14px', overflow:"hidden", 
                                                        transition:"1s", height:showDetails=="show-data-"+data.id ? "0":"auto"}}><span style={{fontWeight:'bold', color:'red'}}>Količina:</span> {donatLast_ak3.num}</div>
                                                        }            

                                                    {data.id==6 && donatLast_ak6 && donatLast_ak6!='' && donatLast_ak6.date && donatLast_ak6.date!=''
                                                        && 
                                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', 
                                                            gap:'5px', lineBreak: 'anywhere', fontSize:'14px', overflow:"hidden", 
                                                            transition:"1s", height:showDetails=="show-data-"+data.id ? "0":"auto"}}>
                                                                <span style={{fontWeight:'bold', color:'red'}}>Datum:</span><br></br> {donatLast_ak6.date}</div>
                                                        }

                                                    {data.id==6 && donatLast_ak6 && donatLast_ak6!=''   
                                                        && 
                                                        <div  style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', 
                                                        gap:'5px', fontSize:'14px', overflow:"hidden", 
                                                        transition:"1s", height:showDetails=="show-data-"+data.id ? "0":"auto"}}><span style={{fontWeight:'bold', color:'red'}}>Količina:</span> {donatLast_ak6.num}</div>
                                                        }                                                              

</div>


                                                  
                                                </div>

                                                <div style={{  display: 'flex', justifyContent: 'center', gap:'10px', alignItems: 'flex-start', justifyContent:"flex-start", gap:'10px', width:'16.667%', flexDirection: 'column'}}>
                                                    
                                                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap:'5px'  }}>                                            
                                               
                                                      <Checkbox
                                                            sx={{padding:0}}
                                                            checked={checkedCheckboxes[data.id]?.tMobile || false}
                                                            onChange={() => handleCheckboxChange(data.id, 'tMobile')}
                                                        />
                                                        <label style={{fontSize:"15px"}}>T-Mobile</label>
                                                    </div>
<div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'center', flexDirection:"column", border:1, borderColor:'red'}}>
                                                    {data.id==1 && tmobileLast_ak1 && tmobileLast_ak1!='' && tmobileLast_ak1.date && tmobileLast_ak1.date!='' 
                                                        && 
                                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', 
                                                            gap:'5px', lineBreak: 'anywhere', fontSize:'14px', overflow:"hidden", 
                                                            transition:"1s", height:showDetails=="show-data-"+data.id ? "0":"auto"}}>
                                                                <span style={{fontWeight:'bold', color:'red'}}>Datum:</span><br></br> {tmobileLast_ak1.date}</div>
                                                     
                                                        }

                                                    {data.id==1  && tmobileLast_ak1 && tmobileLast_ak1!=''  
                                                        && 
                                                        <div  style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', 
                                                        gap:'5px', fontSize:'14px', overflow:"hidden", 
                                                        transition:"1s", height:showDetails=="show-data-"+data.id ? "0":"auto"}}><span style={{fontWeight:'bold', color:'red'}}>Količina:</span> {tmobileLast_ak1.num}</div>
                                                       
                                                        }                    

                                                    {data.id==4 && tmobileLast_ak1 && tmobileLast_ak1!='' && tmobileLast_ak1.date && tmobileLast_ak1.date!='' 
                                                        && 
                                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', 
                                                            gap:'5px', lineBreak: 'anywhere', fontSize:'14px', overflow:"hidden", 
                                                            transition:"1s", height:showDetails=="show-data-"+data.id ? "0":"auto"}}>
                                                                <span style={{fontWeight:'bold', color:'red'}}>Datum:</span><br></br> {tmobileLast_ak1.date}</div>
                                                     
                                                        }

                                                    {data.id==4  
                                                        && 
                                                        <div  style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', 
                                                        gap:'5px', fontSize:'14px', overflow:"hidden", 
                                                        transition:"1s", height:showDetails=="show-data-"+data.id ? "0":"auto"}}><span style={{fontWeight:'bold', color:'red'}}>Količina:</span> 0</div>
                                                       
                                                        }                                                           


                                                    {data.id==5 && tmobileLast_ak1 && tmobileLast_ak1!='' && tmobileLast_ak1.date && tmobileLast_ak1.date!='' 
                                                        && 
                                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', 
                                                            gap:'5px', lineBreak: 'anywhere', fontSize:'14px', overflow:"hidden", 
                                                            transition:"1s", height:showDetails=="show-data-"+data.id ? "0":"auto"}}>
                                                                <span style={{fontWeight:'bold', color:'red'}}>Datum:</span><br></br> {tmobileLast_ak1.date}</div>
                                                     
                                                        }

                                                    {data.id==5  
                                                        && 
                                                        <div  style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', 
                                                        gap:'5px', fontSize:'14px', overflow:"hidden", 
                                                        transition:"1s", height:showDetails=="show-data-"+data.id ? "0":"auto"}}><span style={{fontWeight:'bold', color:'red'}}>Količina:</span> {tmobileLast_ak5.num}</div>
                                                       
                                                        }     

                                                    {data.id==2 && tmobileLast_ak2 && tmobileLast_ak2!='' && tmobileLast_ak2.date && tmobileLast_ak2.date!='' 
                                                        && 
                                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', 
                                                            gap:'5px', lineBreak: 'anywhere', fontSize:'14px', overflow:"hidden", 
                                                            transition:"1s", height:showDetails=="show-data-"+data.id ? "0":"auto"}}>
                                                                <span style={{fontWeight:'bold', color:'red'}}>Datum:</span><br></br> {tmobileLast_ak2.date}</div>
                                                     
                                                        }

                                                    {data.id==2 && tmobileLast_ak2 && tmobileLast_ak2!=''  
                                                        && 
                                                        <div  style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', 
                                                        gap:'5px', fontSize:'14px', overflow:"hidden", 
                                                        transition:"1s", height:showDetails=="show-data-"+data.id ? "0":"auto"}}><span style={{fontWeight:'bold', color:'red'}}>Količina:</span> {tmobileLast_ak2.num}</div>
                                                       
                                                        }   


                                                    {data.id==3 && tmobileLast_ak3 && tmobileLast_ak3!='' && tmobileLast_ak3.date && tmobileLast_ak3.date!=''
                                                        && 
                                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', 
                                                            gap:'5px', lineBreak: 'anywhere', fontSize:'14px', overflow:"hidden", 
                                                            transition:"1s", height:showDetails=="show-data-"+data.id ? "0":"auto"}}>
                                                                <span style={{fontWeight:'bold', color:'red'}}>Datum:</span><br></br> {tmobileLast_ak3.date}</div>
                                                     
                                                        }

                                                    {data.id==3 && tmobileLast_ak3 && tmobileLast_ak3!='' && tmobileLast_ak3.date && tmobileLast_ak3.date!=''   
                                                        && 
                                                        <div  style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', 
                                                        gap:'5px', fontSize:'14px', overflow:"hidden", 
                                                        transition:"1s", height:showDetails=="show-data-"+data.id ? "0":"auto"}}><span style={{fontWeight:'bold', color:'red'}}>Količina:</span> {tmobileLast_ak3.num}</div>
                                                       
                                                        }   

                                                    {data.id==6 && tmobileLast_ak6 && tmobileLast_ak6!='' && tmobileLast_ak6.date && tmobileLast_ak6.date!='' 
                                                        && 
                                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', 
                                                            gap:'5px', lineBreak: 'anywhere', fontSize:'14px', overflow:"hidden", 
                                                            transition:"1s", height:showDetails=="show-data-"+data.id ? "0":"auto"}}>
                                                                <span style={{fontWeight:'bold', color:'red'}}>Datum:</span><br></br> {tmobileLast_ak6.date}</div>
                                                     
                                                        }

                                                    {data.id==6&& tmobileLast_ak6 && tmobileLast_ak6!=''   
                                                        && 
                                                        <div  style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', 
                                                        gap:'5px', fontSize:'14px', overflow:"hidden", 
                                                        transition:"1s", height:showDetails=="show-data-"+data.id ? "0":"auto"}}><span style={{fontWeight:'bold', color:'red'}}>Količina:</span> {tmobileLast_ak6.num}</div>
                                                       
                                                        }   
</div>                                                   
                                                   

                                                   
                                                </div>


                                                <div style={{  display: 'flex', justifyContent: 'center', gap:'10px', alignItems: 'flex-start', justifyContent:"flex-start", gap:'10px', width:'16.667%', flexDirection: 'column' }}>
                                                    
                                                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap:'5px'  }}>   
                                                      <Checkbox
                                                            sx={{padding:0}}
                                                            checked={checkedCheckboxes[data.id]?.ostaliFiks || false}
                                                            onChange={() => handleCheckboxChange(data.id, 'ostaliFiks')}
                                                        />
                                                        <label style={{fontSize:"15px"}}>Ostali fiks</label>
                                                    </div>
                                                  
<div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'center', flexDirection:"column"}}>
                                                    {data.id==1 && ostaliLast_ak1 && ostaliLast_ak1!='' && ostaliLast_ak1.date && ostaliLast_ak1.date!=''  
                                                        && 
                                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', 
                                                            gap:'5px', lineBreak: 'anywhere', fontSize:'14px', overflow:"hidden", 
                                                            transition:"1s", height:showDetails=="show-data-"+data.id ? "0":"auto"}}>
                                                                <span style={{fontWeight:'bold', color:'red'}}>Datum:</span><br></br> {ostaliLast_ak1.date}</div>
                                                    
                                                        }

                                                    {data.id==1  && ostaliLast_ak1 && ostaliLast_ak1!=''  
                                                        && 
                                                        <div  style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', 
                                                        gap:'5px', fontSize:'14px', overflow:"hidden", 
                                                        transition:"1s", height:showDetails=="show-data-"+data.id ? "0":"auto"}}><span style={{fontWeight:'bold', color:'red'}}>Količina:</span> {ostaliLast_ak1.num}</div>
                                                     
                                                        }               

                                                    {data.id==4 && ostaliLast_ak1 && ostaliLast_ak1!='' && ostaliLast_ak1.date && ostaliLast_ak1.date!=''  
                                                        && 
                                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', 
                                                            gap:'5px', lineBreak: 'anywhere', fontSize:'14px', overflow:"hidden", 
                                                            transition:"1s", height:showDetails=="show-data-"+data.id ? "0":"auto"}}>
                                                                <span style={{fontWeight:'bold', color:'red'}}>Datum:</span><br></br> {ostaliLast_ak1.date}</div>
                                                    
                                                        }

                                                    {data.id==4  
                                                        && 
                                                        <div  style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', 
                                                        gap:'5px', fontSize:'14px', overflow:"hidden", 
                                                        transition:"1s", height:showDetails=="show-data-"+data.id ? "0":"auto"}}><span style={{fontWeight:'bold', color:'red'}}>Količina:</span> 0</div>
                                                     
                                                        }       

                                                    {data.id==5 && ostaliLast_ak1 && ostaliLast_ak1!='' && ostaliLast_ak1.date && ostaliLast_ak1.date!=''  
                                                        && 
                                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', 
                                                            gap:'5px', lineBreak: 'anywhere', fontSize:'14px', overflow:"hidden", 
                                                            transition:"1s", height:showDetails=="show-data-"+data.id ? "0":"auto"}}>
                                                                <span style={{fontWeight:'bold', color:'red'}}>Datum:</span><br></br> {ostaliLast_ak1.date}</div>
                                                    
                                                        }

                                                    {data.id==5 
                                                        && 
                                                        <div  style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', 
                                                        gap:'5px', fontSize:'14px', overflow:"hidden", 
                                                        transition:"1s", height:showDetails=="show-data-"+data.id ? "0":"auto"}}><span style={{fontWeight:'bold', color:'red'}}>Količina:</span> 0</div>
                                                     
                                                        }                                                                                                                                   

                                                    {data.id==2 && ostaliLast_ak2 && ostaliLast_ak2!='' && ostaliLast_ak2.date && ostaliLast_ak2.date!=''   
                                                        && 
                                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', 
                                                            gap:'5px', lineBreak: 'anywhere', fontSize:'14px', overflow:"hidden", 
                                                            transition:"1s", height:showDetails=="show-data-"+data.id ? "0":"auto"}}>
                                                                <span style={{fontWeight:'bold', color:'red'}}>Datum:</span><br></br> {ostaliLast_ak2.date}</div>
                                                    
                                                        }

                                                    {data.id==2 && ostaliLast_ak2 && ostaliLast_ak2!='' 
                                                        && 
                                                        <div  style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', 
                                                        gap:'5px', fontSize:'14px', overflow:"hidden", 
                                                        transition:"1s", height:showDetails=="show-data-"+data.id ? "0":"auto"}}><span style={{fontWeight:'bold', color:'red'}}>Količina:</span> {ostaliLast_ak2.num}</div>
                                                     
                                                        }                                                           


                                                    {data.id==3 && ostaliLast_ak3 && ostaliLast_ak3!='' && ostaliLast_ak3.date && ostaliLast_ak3.date!=''   
                                                        && 
                                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', 
                                                            gap:'5px', lineBreak: 'anywhere', fontSize:'14px', overflow:"hidden", 
                                                            transition:"1s", height:showDetails=="show-data-"+data.id ? "0":"auto"}}>
                                                                <span style={{fontWeight:'bold', color:'red'}}>Datum:</span><br></br> {ostaliLast_ak3.date}</div>
                                                    
                                                        }

                                                    {data.id==3 && ostaliLast_ak3 && ostaliLast_ak3!='' 
                                                        && 
                                                        <div  style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', 
                                                        gap:'5px', fontSize:'14px', overflow:"hidden", 
                                                        transition:"1s", height:showDetails=="show-data-"+data.id ? "0":"auto"}}><span style={{fontWeight:'bold', color:'red'}}>Količina:</span> {ostaliLast_ak3.num}</div>
                                                     
                                                        }  

                                                    {data.id==6 && ostaliLast_ak6 && ostaliLast_ak6!='' && ostaliLast_ak6.date && ostaliLast_ak6.date!=''   
                                                        && 
                                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', 
                                                            gap:'5px', lineBreak: 'anywhere', fontSize:'14px', overflow:"hidden", 
                                                            transition:"1s", height:showDetails=="show-data-"+data.id ? "0":"auto"}}>
                                                                <span style={{fontWeight:'bold', color:'red'}}>Datum:</span><br></br> {ostaliLast_ak6.date}</div>
                                                    
                                                        }

                                                    {data.id==6 && ostaliLast_ak6 && ostaliLast_ak6!='' 
                                                        && 
                                                        <div  style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', 
                                                        gap:'5px', fontSize:'14px', overflow:"hidden", 
                                                        transition:"1s", height:showDetails=="show-data-"+data.id ? "0":"auto"}}><span style={{fontWeight:'bold', color:'red'}}>Količina:</span> {ostaliLast_ak6.num}</div>
                                                     
                                                        }                                                         
</div>                                                   

                                                  
                                                  
                                                </div>


                                                <div style={{  display: 'flex', justifyContent: 'center', gap:'10px', alignItems: 'flex-start', justifyContent:"flex-start", gap:'10px', width:'16.667%', flexDirection: 'column' }}>
                                                    
                                                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap:'5px'  }}>   

                                                      <Checkbox
                                                            sx={{padding:0}}
                                                            checked={checkedCheckboxes[data.id]?.tele2 || false}
                                                            onChange={() => handleCheckboxChange(data.id, 'tele2')}
                                                        />
                                                        <label style={{fontSize:"15px"}}>Telemach</label>
                                                    </div>
                                                   
<div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'center', flexDirection:"column"}}>
                                                    {data.id==1 && teleLast_ak1 && teleLast_ak1!='' && teleLast_ak1.date && teleLast_ak1.date!=''  
                                                        && 
                                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', 
                                                            gap:'5px', lineBreak: 'anywhere', fontSize:'14px', overflow:"hidden", 
                                                            transition:"1s", height:showDetails=="show-data-"+data.id ? "0":"auto"}}>
                                                                <span style={{fontWeight:'bold', color:'red'}}>Datum:</span><br></br> {teleLast_ak1.date}</div>
                                                        
                                                        }

                                                    {data.id==1  && teleLast_ak1 && teleLast_ak1!=''  
                                                        && 
                                                        <div  style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', 
                                                        gap:'5px', fontSize:'14px', overflow:"hidden", 
                                                        transition:"1s", height:showDetails=="show-data-"+data.id ? "0":"auto"}}><span style={{fontWeight:'bold', color:'red'}}>Količina:</span> {teleLast_ak1.num}</div>
                                                        
                                                        }                                 


                                                    {data.id==4 && teleLast_ak1 && teleLast_ak1!='' && teleLast_ak1.date && teleLast_ak1.date!='' 
                                                        && 
                                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', 
                                                            gap:'5px', lineBreak: 'anywhere', fontSize:'14px', overflow:"hidden", 
                                                            transition:"1s", height:showDetails=="show-data-"+data.id ? "0":"auto"}}>
                                                                <span style={{fontWeight:'bold', color:'red'}}>Datum:</span><br></br> {teleLast_ak1.date}</div>
                                                        
                                                        }

                                                    {data.id==4
                                                        && 
                                                        <div  style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', 
                                                        gap:'5px', fontSize:'14px', overflow:"hidden", 
                                                        transition:"1s", height:showDetails=="show-data-"+data.id ? "0":"auto"}}><span style={{fontWeight:'bold', color:'red'}}>Količina:</span> 0</div>
                                                        
                                                        }      

                                                    {data.id==5 && teleLast_ak1 && teleLast_ak1!='' && teleLast_ak1.date && teleLast_ak1.date!='' 
                                                        && 
                                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', 
                                                            gap:'5px', lineBreak: 'anywhere', fontSize:'14px', overflow:"hidden", 
                                                            transition:"1s", height:showDetails=="show-data-"+data.id ? "0":"auto"}}>
                                                                <span style={{fontWeight:'bold', color:'red'}}>Datum:</span><br></br> {teleLast_ak1.date}</div>
                                                        
                                                        }

                                                    {data.id==5
                                                        && 
                                                        <div  style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', 
                                                        gap:'5px', fontSize:'14px', overflow:"hidden", 
                                                        transition:"1s", height:showDetails=="show-data-"+data.id ? "0":"auto"}}><span style={{fontWeight:'bold', color:'red'}}>Količina:</span> 0</div>
                                                        
                                                        }        

                                                    {data.id==2 && teleLast_ak2 && teleLast_ak2!='' && teleLast_ak2.date && teleLast_ak2.date!='' 
                                                        && 
                                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', 
                                                            gap:'5px', lineBreak: 'anywhere', fontSize:'14px', overflow:"hidden", 
                                                            transition:"1s", height:showDetails=="show-data-"+data.id ? "0":"auto"}}>
                                                                <span style={{fontWeight:'bold', color:'red'}}>Datum:</span><br></br> {teleLast_ak2.date}</div>
                                                        
                                                        }

                                                    {data.id==2 && teleLast_ak2 && teleLast_ak2!=''
                                                        && 
                                                        <div  style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', 
                                                        gap:'5px', fontSize:'14px', overflow:"hidden", 
                                                        transition:"1s", height:showDetails=="show-data-"+data.id ? "0":"auto"}}><span style={{fontWeight:'bold', color:'red'}}>Količina:</span> {teleLast_ak2.num}</div>
                                                        
                                                        }                                                                                                                                   

                                                    {data.id==3 && teleLast_ak3 && teleLast_ak3!='' && teleLast_ak3.date && teleLast_ak3.date!='' 
                                                        && 
                                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', 
                                                            gap:'5px', lineBreak: 'anywhere', fontSize:'14px', overflow:"hidden", 
                                                            transition:"1s", height:showDetails=="show-data-"+data.id ? "0":"auto"}}>
                                                                <span style={{fontWeight:'bold', color:'red'}}>Datum:</span><br></br> {teleLast_ak3.date}</div>
                                                        
                                                        }

                                                    {data.id==3 && teleLast_ak3 && teleLast_ak3!=''
                                                        && 
                                                        <div  style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', 
                                                        gap:'5px', fontSize:'14px', overflow:"hidden", 
                                                        transition:"1s", height:showDetails=="show-data-"+data.id ? "0":"auto"}}><span style={{fontWeight:'bold', color:'red'}}>Količina:</span> {teleLast_ak3.num}</div>
                                                        
                                                        }    

                                                    {data.id==6 && teleLast_ak6 && teleLast_ak6!='' && teleLast_ak6.date && teleLast_ak6.date!='' 
                                                        && 
                                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', 
                                                            gap:'5px', lineBreak: 'anywhere', fontSize:'14px', overflow:"hidden", 
                                                            transition:"1s", height:showDetails=="show-data-"+data.id ? "0":"auto"}}>
                                                                <span style={{fontWeight:'bold', color:'red'}}>Datum:</span><br></br> {teleLast_ak6.date}</div>
                                                        
                                                        }

                                                    {data.id==6&& teleLast_ak6 && teleLast_ak6!='' 
                                                        && 
                                                        <div  style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', 
                                                        gap:'5px', fontSize:'14px', overflow:"hidden", 
                                                        transition:"1s", height:showDetails=="show-data-"+data.id ? "0":"auto"}}><span style={{fontWeight:'bold', color:'red'}}>Količina:</span> {teleLast_ak6.num}</div>
                                                        
                                                        }                                                            
</div>          




                                                </div>



                                                <div style={{  display: 'flex', justifyContent: 'center', gap:'10px', alignItems: 'flex-start', justifyContent:"flex-start", gap:'10px', width:'16.667%', 
                                                        flexDirection: 'column' 
                                                    }}>
                                                    
                                                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap:'5px'  }}>   

                                                      <Checkbox
                                                            sx={{padding:0}}
                                                            checked={checkedCheckboxes[data.id]?.vipnet || false}
                                                            onChange={() => handleCheckboxChange(data.id, 'vipnet')}
                                                        />
                                                        <label style={{fontSize:"15px"}}>A1</label>
                                                    </div>
                                                   

                                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'center', flexDirection:"column", }}>
                                                    {data.id==1 && a1Last_ak1 && a1Last_ak1!='' && a1Last_ak1.date && a1Last_ak1.date!=''  
                                                        && 
                                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', 
                                                            gap:'5px', lineBreak: 'anywhere', fontSize:'14px', overflow:"hidden", 
                                                            transition:"1s", height:showDetails=="show-data-"+data.id ? "0":"auto"}}>
                                                                <span style={{fontWeight:'bold', color:'red'}}>Datum:</span><br></br> {a1Last_ak1.date}</div>
                                                       
                                                        }

                                                    {data.id==1  && a1Last_ak1 && a1Last_ak1!=''  
                                                        && 
                                                        <div  style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', 
                                                        gap:'5px', fontSize:'14px', overflow:"hidden", 
                                                        transition:"1s", height:showDetails=="show-data-"+data.id ? "0":"auto"}}><span style={{fontWeight:'bold', color:'red'}}>Količina:</span> {a1Last_ak1.num}</div>
                                                        
                                                        }      

                                                    {data.id==4 && a1Last_ak1 && a1Last_ak1!='' && a1Last_ak1.date && a1Last_ak1.date!=''  
                                                        && 
                                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', 
                                                            gap:'5px', lineBreak: 'anywhere', fontSize:'14px', overflow:"hidden", 
                                                            transition:"1s", height:showDetails=="show-data-"+data.id ? "0":"auto"}}>
                                                                <span style={{fontWeight:'bold', color:'red'}}>Datum:</span><br></br> {a1Last_ak1.date}</div>
                                                       
                                                        }

                                                    {data.id==4  
                                                        && 
                                                        <div  style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', 
                                                        gap:'5px', fontSize:'14px', overflow:"hidden", 
                                                        transition:"1s", height:showDetails=="show-data-"+data.id ? "0":"auto"}}><span style={{fontWeight:'bold', color:'red'}}>Količina:</span> 0</div>
                                                        
                                                        }                                                          

                                                    {data.id==5 && a1Last_ak1 && a1Last_ak1!='' && a1Last_ak1.date && a1Last_ak1.date!=''  
                                                        && 
                                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', 
                                                            gap:'5px', lineBreak: 'anywhere', fontSize:'14px', overflow:"hidden", 
                                                            transition:"1s", height:showDetails=="show-data-"+data.id ? "0":"auto"}}>
                                                                <span style={{fontWeight:'bold', color:'red'}}>Datum:</span><br></br> {a1Last_ak1.date}</div>
                                                       
                                                        }

                                                    {data.id==5  
                                                        && 
                                                        <div  style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', 
                                                        gap:'5px', fontSize:'14px', overflow:"hidden", 
                                                        transition:"1s", height:showDetails=="show-data-"+data.id ? "0":"auto"}}><span style={{fontWeight:'bold', color:'red'}}>Količina:</span> 0</div>
                                                        
                                                        }  

                                                    {data.id==2 && a1Last_ak2 && a1Last_ak2!='' && a1Last_ak2.date && a1Last_ak2.date!=''  
                                                        && 
                                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', 
                                                            gap:'5px', lineBreak: 'anywhere', fontSize:'14px', overflow:"hidden", 
                                                            transition:"1s", height:showDetails=="show-data-"+data.id ? "0":"auto"}}>
                                                                <span style={{fontWeight:'bold', color:'red'}}>Datum:</span><br></br> {a1Last_ak2.date}</div>
                                                       
                                                        }

                                                    {data.id==2 && a1Last_ak2 && a1Last_ak2!='' 
                                                        && 
                                                        <div  style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', 
                                                        gap:'5px', fontSize:'14px', overflow:"hidden", 
                                                        transition:"1s", height:showDetails=="show-data-"+data.id ? "0":"auto"}}><span style={{fontWeight:'bold', color:'red'}}>Količina:</span> {a1Last_ak2.num}</div>
                                                        
                                                        }  

                                                    {data.id==3 && a1Last_ak3 && a1Last_ak3!='' && a1Last_ak3.date && a1Last_ak3.date!='' 
                                                        && 
                                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', 
                                                            gap:'5px', lineBreak: 'anywhere', fontSize:'14px', overflow:"hidden", 
                                                            transition:"1s", height:showDetails=="show-data-"+data.id ? "0":"auto"}}>
                                                                <span style={{fontWeight:'bold', color:'red'}}>Datum:</span><br></br> {a1Last_ak3.date}</div>
                                                       
                                                        }

                                                    {data.id==3 && a1Last_ak3 && a1Last_ak3!='' 
                                                        && 
                                                        <div  style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', 
                                                        gap:'5px', fontSize:'14px', overflow:"hidden", 
                                                        transition:"1s", height:showDetails=="show-data-"+data.id ? "0":"auto"}}><span style={{fontWeight:'bold', color:'red'}}>Količina:</span> {a1Last_ak3.num}</div>
                                                        
                                                        }  


                                                    {data.id==6 && a1Last_ak6 && a1Last_ak6!='' && a1Last_ak6.date && a1Last_ak6.date!='' 
                                                        && 
                                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', 
                                                            gap:'5px', lineBreak: 'anywhere', fontSize:'14px', overflow:"hidden", 
                                                            transition:"1s", height:showDetails=="show-data-"+data.id ? "0":"auto"}}>
                                                                <span style={{fontWeight:'bold', color:'red'}}>Datum:</span><br></br> {a1Last_ak6.date}</div>
                                                       
                                                        }

                                                    {data.id==6&& a1Last_ak6 && a1Last_ak6!='' 
                                                        && 
                                                        <div  style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', 
                                                        gap:'5px', fontSize:'14px', overflow:"hidden", 
                                                        transition:"1s", height:showDetails=="show-data-"+data.id ? "0":"auto"}}><span style={{fontWeight:'bold', color:'red'}}>Količina:</span> {a1Last_ak6.num}</div>
                                                        
                                                        }  

                                                </div>          



                                                </div>



                                            </div>
                                        </div>



                                    </ListItem>
                                ))}
                            </List>
                        </div>


                    </div >
                </div >

            </div >
        )
    }

    const kreniDiv2ButtonFunction = () => {
         dispatch(actions.isLoading());
        console.log("KRENI DIV 2")
        dispatch(actions.isNotLoading());
    }

    const krajDiv2ButtonFunction = () => {
         dispatch(actions.isLoading());
        console.log("KRAJ DIV 2")
        setDisplayedComponent(null);
        dispatch(actions.isNotLoading());
    }

    const [selectedRowsDiv2, setSelectedRowsDiv2] = useState([]);

    const handleRowClickDiv2 = (index) => {
        const selectedIndex = selectedRowsDiv2.indexOf(index);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = [...selectedRowsDiv2, index];
        } else {
            newSelected = [...selectedRowsDiv2.slice(0, selectedIndex), ...selectedRowsDiv2.slice(selectedIndex + 1)];
        }

        setSelectedRowsDiv2(newSelected);
    };

    const mockDataDiv2 = [
        {
            column1: 'Item 1',
            column2: 'Description 1',
            column3: 10,
            column4: 'Category A',
            column5: 'Vendor X',
            column6: 50.0,
            column7: 'Location A',
            column8: 'In Stock',
            column9: '2023-09-01',
            column10: 'User A',
            column11: 'Notes for Item 1',
            column12: 'Review 1',
            column13: 'Approved',
        },
        {
            column1: 'Item 2',
            column2: 'Description 2',
            column3: 5,
            column4: 'Category B',
            column5: 'Vendor Y',
            column6: 25.0,
            column7: 'Location B',
            column8: 'Out of Stock',
            column9: '2023-09-05',
            column10: 'User B',
            column11: 'Notes for Item 2',
            column12: 'Review 2',
            column13: 'Rejected',
        }, {
            column1: 'Item 1',
            column2: 'Description 1',
            column3: 10,
            column4: 'Category A',
            column5: 'Vendor X',
            column6: 50.0,
            column7: 'Location A',
            column8: 'In Stock',
            column9: '2023-09-01',
            column10: 'User A',
            column11: 'Notes for Item 1',
            column12: 'Review 1',
            column13: 'Approved',
        },
        {
            column1: 'Item 2',
            column2: 'Description 2',
            column3: 5,
            column4: 'Category B',
            column5: 'Vendor Y',
            column6: 25.0,
            column7: 'Location B',
            column8: 'Out of Stock',
            column9: '2023-09-05',
            column10: 'User B',
            column11: 'Notes for Item 2',
            column12: 'Review 2',
            column13: 'Rejected',
        }, {
            column1: 'Item 1',
            column2: 'Description 1',
            column3: 10,
            column4: 'Category A',
            column5: 'Vendor X',
            column6: 50.0,
            column7: 'Location A',
            column8: 'In Stock',
            column9: '2023-09-01',
            column10: 'User A',
            column11: 'Notes for Item 1',
            column12: 'Review 1',
            column13: 'Approved',
        },
        {
            column1: 'Item 2',
            column2: 'Description 2',
            column3: 5,
            column4: 'Category B',
            column5: 'Vendor Y',
            column6: 25.0,
            column7: 'Location B',
            column8: 'Out of Stock',
            column9: '2023-09-05',
            column10: 'User B',
            column11: 'Notes for Item 2',
            column12: 'Review 2',
            column13: 'Rejected',
        }, {
            column1: 'Item 1',
            column2: 'Description 1',
            column3: 10,
            column4: 'Category A',
            column5: 'Vendor X',
            column6: 50.0,
            column7: 'Location A',
            column8: 'In Stock',
            column9: '2023-09-01',
            column10: 'User A',
            column11: 'Notes for Item 1',
            column12: 'Review 1',
            column13: 'Approved',
        },
        {
            column1: 'Item 2',
            column2: 'Description 2',
            column3: 5,
            column4: 'Category B',
            column5: 'Vendor Y',
            column6: 25.0,
            column7: 'Location B',
            column8: 'Out of Stock',
            column9: '2023-09-05',
            column10: 'User B',
            column11: 'Notes for Item 2',
            column12: 'Review 2',
            column13: 'Rejected',
        }, {
            column1: 'Item 1',
            column2: 'Description 1',
            column3: 10,
            column4: 'Category A',
            column5: 'Vendor X',
            column6: 50.0,
            column7: 'Location A',
            column8: 'In Stock',
            column9: '2023-09-01',
            column10: 'User A',
            column11: 'Notes for Item 1',
            column12: 'Review 1',
            column13: 'Approved',
        },
        {
            column1: 'Item 2',
            column2: 'Description 2',
            column3: 5,
            column4: 'Category B',
            column5: 'Vendor Y',
            column6: 25.0,
            column7: 'Location B',
            column8: 'Out of Stock',
            column9: '2023-09-05',
            column10: 'User B',
            column11: 'Notes for Item 2',
            column12: 'Review 2',
            column13: 'Rejected',
        }, {
            column1: 'Item 1',
            column2: 'Description 1',
            column3: 10,
            column4: 'Category A',
            column5: 'Vendor X',
            column6: 50.0,
            column7: 'Location A',
            column8: 'In Stock',
            column9: '2023-09-01',
            column10: 'User A',
            column11: 'Notes for Item 1',
            column12: 'Review 1',
            column13: 'Approved',
        },
        {
            column1: 'Item 2',
            column2: 'Description 2',
            column3: 5,
            column4: 'Category B',
            column5: 'Vendor Y',
            column6: 25.0,
            column7: 'Location B',
            column8: 'Out of Stock',
            column9: '2023-09-05',
            column10: 'User B',
            column11: 'Notes for Item 2',
            column12: 'Review 2',
            column13: 'Rejected',
        }, {
            column1: 'Item 1',
            column2: 'Description 1',
            column3: 10,
            column4: 'Category A',
            column5: 'Vendor X',
            column6: 50.0,
            column7: 'Location A',
            column8: 'In Stock',
            column9: '2023-09-01',
            column10: 'User A',
            column11: 'Notes for Item 1',
            column12: 'Review 1',
            column13: 'Approved',
        },
        {
            column1: 'Item 2',
            column2: 'Description 2',
            column3: 5,
            column4: 'Category B',
            column5: 'Vendor Y',
            column6: 25.0,
            column7: 'Location B',
            column8: 'Out of Stock',
            column9: '2023-09-05',
            column10: 'User B',
            column11: 'Notes for Item 2',
            column12: 'Review 2',
            column13: 'Rejected',
        }
    ];

    const TrenutnoStanjeSpiskovaKomponenta = () => {
        return (
            <div className={styles.container}>
                {/*Botuni box*/}
                <div className={styles.buttonCard}>
                    <div className={styles.mainButtonContainer}>
                        <div className={styles.buttonContainerDiv2}>
                            <Button
                                fullWidth
                                variant="contained"
                                onClick={() => {
                                    mjesecniIzvjestajoStanjuSpiskovaButtonFunction()
                                }}
                            >
                                Mjesečni izvještaj o stanju spiskova
                            </Button>
                        </div>
                    </div>
                </div>

                {/*Naslov i botuni*/}
                <div className={styles.buttonCard}>
                    <div className={styles.mainButtonContainer}>
                        <div style={{ width: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <p style={{ fontWeight: 'bold', fontSize: '1.2rem' }}>TRENUTNO STANJE SPISKOVA ZA CIJELU HRVATSKU</p>
                        </div>
                        <div style={{ display: 'flex', width: '50%' }}>
                            <div className={styles.buttonContainer}>
                                <Button
                                    fullWidth
                                    variant="contained"
                                    onClick={() => {
                                        kreniDiv2ButtonFunction()
                                    }}
                                >
                                    KRENI
                                </Button>
                            </div>
                            <div className={styles.buttonContainer}>
                                <Button
                                    fullWidth
                                    variant="contained"
                                    onClick={() => {
                                        krajDiv2ButtonFunction()
                                    }}
                                >
                                    KRAJ
                                </Button>
                            </div>
                        </div>

                    </div>
                </div>

                {/*Tablica*/}
                <div className={styles.tableAndButtonContainer}>
                    {/*Prvi box*/}
                    <div className={styles.tableContainer}>
                        <TableContainer>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        {/* Define your table headers here */}
                                        <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 1</TableCell>
                                        <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 2</TableCell>
                                        <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 3</TableCell>
                                        <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 4</TableCell>
                                        <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 5</TableCell>
                                        <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 6</TableCell>
                                        <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 7</TableCell>
                                        <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 8</TableCell>
                                        <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 9</TableCell>
                                        <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 10</TableCell>
                                        <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 11</TableCell>
                                        <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 12</TableCell>
                                        <TableCell style={{ textAlign: 'center', fontWeight: 'bold' }}>Column 13</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {mockDataDiv2.map((item, index) => (
                                        <TableRow key={index} onClick={() => handleRowClickDiv2(index)} selected={selectedRowsDiv2.includes(index)}>
                                            {/* Map your data to the table rows */}
                                            <TableCell style={{ textAlign: 'center' }}>{item.column1}</TableCell>
                                            <TableCell style={{ textAlign: 'center' }}>{item.column2}</TableCell>
                                            <TableCell style={{ textAlign: 'center' }}>{item.column3}</TableCell>
                                            <TableCell style={{ textAlign: 'center' }}>{item.column4}</TableCell>
                                            <TableCell style={{ textAlign: 'center' }}>{item.column5}</TableCell>
                                            <TableCell style={{ textAlign: 'center' }}>{item.column6}</TableCell>
                                            <TableCell style={{ textAlign: 'center' }}>{item.column7}</TableCell>
                                            <TableCell style={{ textAlign: 'center' }}>{item.column8}</TableCell>
                                            <TableCell style={{ textAlign: 'center' }}>{item.column9}</TableCell>
                                            <TableCell style={{ textAlign: 'center' }}>{item.column10}</TableCell>
                                            <TableCell style={{ textAlign: 'center' }}>{item.column11}</TableCell>
                                            <TableCell style={{ textAlign: 'center' }}>{item.column12}</TableCell>
                                            <TableCell style={{ textAlign: 'center' }}>{item.column13}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                </div>

            </div>

        )
    }

    const FiltriranjePoOperatorima = () => {
        return (
            <div className={styles.container}>
                {/*Botuni box*/}
                <div className={styles.buttonCard}>
                    <div className={styles.mainButtonContainer}>
                        <div className={styles.buttonContainerDiv2}>
                            <Button
                                fullWidth
                                variant="contained"
                                onClick={() => {
                                    trenutnoStanjeSpiskovaButtonFunction()
                                }}
                            >
                                Trenutno stanje spiskova
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }




const [currShow, setCurrShow] = useState(false);
const [listDonat, setListDonat] = useState([]);
const [listAll, setListAll] = useState([]);
const [listUkupno, setListUkupno] = useState([]);
const [modalRowToBeShown, setModalRowToBeShown]= useState('')
    return (
        <ThemeProvider theme={theme}>

                <Modal
                open={openModal}
                onClose={()=> {
                    setOpenModal(false)
                }}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box className={styles["nadzori-upravljanje-modal-container"]} 
                 ref={popupRef}
                 onClick={(e) => e.stopPropagation()}
                
                 style={{ transform: `translate(${modalPosition.x}px, ${modalPosition.y}px)` }}>
                <TableContainer  sx={{ resize: 'both' }} >
                            <Table stickyHeader aria-label="sticky table" sx={{ minWidth: 650 }} >
                                <TableHead onMouseDown={(e)=> onMouseDown(e)}>
                                    <TableRow className={styles['nadzori-header']}>
                                       
                                        <TableCell className={styles['nadzori-header-cell']} sx={{fontWeight:600, backgroundColor:'lightblue'}}>Vrsta</TableCell>
                                        <TableCell className={styles['nadzori-header-cell']} sx={{fontWeight:600, backgroundColor:'lightblue', borderRight:1}} align="right">Cijela RH</TableCell>

                                  

                                        {listAll.map((row) => (
                                            


                                            <TableCell className={styles['nadzori-header-cell']} sx={{fontWeight:600, backgroundColor:'lightblue', borderRight:1}} align="right">{row.mreza}</TableCell>
                                            

                                        ))}

        
               

                                    </TableRow>
                                </TableHead>
                                <TableBody>

                                        <TableRow className={styles['nadzori-row-header']} onClick={() => {
                                                    //setModalRowToBeShown(modalRowToBeShown=='donat' ? "" : "donat")
                                                    setModalRowToBeShown(modalRowToBeShown=='all' ? "" : "all")



                                                }}
                                            //{/*key={state.rbr}*/}
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                            {/*<TableCell component="th" scope="row" sx={{padding:"9px", fontWeight:600}} >*/}
                                            <TableCell component="th" scope="row" sx={{paddingTop: 0.6, paddingBottom: 0.6, fontWeight:600}} >
                                                Donat ukupno redaka
                                            </TableCell>
                                                {/*<TableCell align="right">{listDonat[0]?(listDonat[0].stanjeAll_d?listDonat[0].stanjeAll_d:0):0}</TableCell>*/}
                                                
                                               

                                                <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, fontWeight:600, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanjeAll_d:'-'}</TableCell>
                                           
<TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, fontWeight:600, borderRight:1}} align="right">{'-'}</TableCell>

                                                <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, fontWeight:600, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanjeuk_01_d:'-'}</TableCell>
                                             
                                                <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, fontWeight:600, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanjeuk_020_d:'-'}</TableCell>  
                                              
                                                <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, fontWeight:600, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanjeuk_021_d:'-'}</TableCell>
                                                <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, fontWeight:600, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanjeuk_022_d:'-'}</TableCell> 
                                                <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, fontWeight:600, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanjeuk_023_d:'-'}</TableCell> 
                                                <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, fontWeight:600, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanjeuk_031_d:'-'}</TableCell> 
                                                <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, fontWeight:600, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanjeuk_032_d:'-'}</TableCell> 
                                                <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, fontWeight:600, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanjeuk_033_d:'-'}</TableCell>
                                                <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, fontWeight:600, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanjeuk_034_d:'-'}</TableCell>
                                                <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, fontWeight:600, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanjeuk_035_d:'-'}</TableCell>  
                                                <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, fontWeight:600, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanjeuk_040_d:'-'}</TableCell> 
                                                <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, fontWeight:600, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanjeuk_042_d:'-'}</TableCell> 
                                                <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, fontWeight:600, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanjeuk_043_d:'-'}</TableCell> 
                                                <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, fontWeight:600, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanjeuk_044_d:'-'}</TableCell> 
                                                <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, fontWeight:600, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanjeuk_047_d:'-'}</TableCell>
                                                <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, fontWeight:600, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanjeuk_048_d:'-'}</TableCell>
                                                <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, fontWeight:600, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanjeuk_049_d:'-'}</TableCell>         
                                                <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, fontWeight:600, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanjeuk_051_d:'-'}</TableCell> 
                                                <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, fontWeight:600, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanjeuk_052_d:'-'}</TableCell>
                                                <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, fontWeight:600, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanjeuk_053_d:'-'}</TableCell>

                                        </TableRow >
                                            <div className={styles['table-row-container']} style={{display:(modalRowToBeShown=="donat" || modalRowToBeShown=='all')?  "contents" : "none"}}>
                                                <TableRow
                                                    //{/*key={state.rbr}*/}
                                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                    >
                                                    <TableCell component="th" scope="row" sx={{paddingTop: 0.6, paddingBottom: 0.6,}} >
                                                        Donat 0
                                                    </TableCell>
                                                    {/*<TableCell align="right">{listDonat[0]?(listDonat[0].stanjeAll_d?listDonat[0].stanjeAll_d:0):0}</TableCell>*/}
                                                   
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6,borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje0_d:'-'}</TableCell>

                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, fontWeight:600, borderRight:1}} align="right">{'-'}</TableCell>
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje0_01_d:'-'}</TableCell>
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje0_020_d:'-'}</TableCell>  
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje0_021_d:'-'}</TableCell>
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje0_022_d:'-'}</TableCell> 
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje0_023_d:'-'}</TableCell> 
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje0_031_d:'-'}</TableCell> 
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje0_032_d:'-'}</TableCell> 
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje0_033_d:'-'}</TableCell>
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje0_034_d:'-'}</TableCell>
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje0_035_d:'-'}</TableCell>  
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje0_040_d:'-'}</TableCell> 
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje0_042_d:'-'}</TableCell> 
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje0_043_d:'-'}</TableCell> 
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje0_044_d:'-'}</TableCell> 
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje0_047_d:'-'}</TableCell>
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje0_048_d:'-'}</TableCell>
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje0_049_d:'-'}</TableCell>         
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje0_051_d:'-'}</TableCell> 
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje0_052_d:'-'}</TableCell>
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje0_053_d:'-'}</TableCell>
                                                
                                                </TableRow>


                                                <TableRow
                                                //</TableBody>*} key={state.rbr}*
                                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                    >
                                                    <TableCell component="th" scope="row" sx={{paddingTop: 0.6, paddingBottom: 0.6}} >
                                                        Donat 6
                                                    </TableCell>
                                                  
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje6_d:'-'}</TableCell>

                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, fontWeight:600, borderRight:1}} align="right">{'-'}</TableCell>
                                                    <TableCell  sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje6_01_d:'-'}</TableCell>
                                                    <TableCell  sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje6_020_d:'-'}</TableCell>  
                                                    <TableCell  sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje6_021_d:'-'}</TableCell>
                                                    <TableCell  sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje6_022_d:'-'}</TableCell> 
                                                    <TableCell  sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje6_023_d:'-'}</TableCell> 
                                                    <TableCell  sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje6_031_d:'-'}</TableCell> 
                                                    <TableCell  sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje6_032_d:'-'}</TableCell> 
                                                    <TableCell  sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje6_033_d:'-'}</TableCell>
                                                    <TableCell  sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje6_034_d:'-'}</TableCell>
                                                    <TableCell  sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje6_035_d:'-'}</TableCell>  
                                                    <TableCell  sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje6_040_d:'-'}</TableCell> 
                                                    <TableCell  sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje6_042_d:'-'}</TableCell> 
                                                    <TableCell  sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje6_043_d:'-'}</TableCell> 
                                                    <TableCell  sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje6_044_d:'-'}</TableCell> 
                                                    <TableCell  sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje6_047_d:'-'}</TableCell>
                                                    <TableCell  sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje6_048_d:'-'}</TableCell>
                                                    <TableCell  sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje6_049_d:'-'}</TableCell>         
                                                    <TableCell  sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje6_051_d:'-'}</TableCell> 
                                                    <TableCell  sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje6_052_d:'-'}</TableCell>
                                                    <TableCell  sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje6_053_d:'-'}</TableCell>

                                                </TableRow>

                                                <TableRow
                                                //</TableBody>*} key={state.rbr}*
                                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                    >
                                                    <TableCell component="th" scope="row" sx={{paddingTop: 0.6, paddingBottom: 0.6}} >
                                                        Donat 0,1,3,5,6
                                                    </TableCell>
                                                   
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje01356_d:'-'}</TableCell>

                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, fontWeight:600, borderRight:1}} align="right">{'-'}</TableCell>
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje01356_01_d:'-'}</TableCell>
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje01356_020_d:'-'}</TableCell>  
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje01356_021_d:'-'}</TableCell>
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje01356_022_d:'-'}</TableCell> 
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje01356_023_d:'-'}</TableCell> 
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje01356_031_d:'-'}</TableCell> 
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje01356_032_d:'-'}</TableCell> 
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje01356_033_d:'-'}</TableCell>
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje01356_034_d:'-'}</TableCell>
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje01356_035_d:'-'}</TableCell>  
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje01356_040_d:'-'}</TableCell> 
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje01356_042_d:'-'}</TableCell> 
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje01356_043_d:'-'}</TableCell> 
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje01356_044_d:'-'}</TableCell> 
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje01356_047_d:'-'}</TableCell>
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje01356_048_d:'-'}</TableCell>
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje01356_049_d:'-'}</TableCell>         
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje01356_051_d:'-'}</TableCell> 
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje01356_052_d:'-'}</TableCell>
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje01356_053_d:'-'}</TableCell>
                                                </TableRow>

                                                <TableRow
                                               
                                                    //sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                    >
                                                    <TableCell component="th" scope="row" sx={{paddingTop: 0.6, paddingBottom: 0.6}} >
                                                        Donat 2,0
                                                    </TableCell>
                                                    
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje2_d:'-'}</TableCell>

                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, fontWeight:600, borderRight:1}} align="right">{'-'}</TableCell>
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje2_01_d:'-'}</TableCell>
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje2_020_d:'-'}</TableCell>  
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje2_021_d:'-'}</TableCell>
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje2_022_d:'-'}</TableCell> 
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje2_023_d:'-'}</TableCell> 
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje2_031_d:'-'}</TableCell> 
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje2_032_d:'-'}</TableCell> 
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje2_033_d:'-'}</TableCell>
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje2_034_d:'-'}</TableCell>
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje2_035_d:'-'}</TableCell>  
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje2_040_d:'-'}</TableCell> 
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje2_042_d:'-'}</TableCell> 
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje2_043_d:'-'}</TableCell> 
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje2_044_d:'-'}</TableCell> 
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje2_047_d:'-'}</TableCell>
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje2_048_d:'-'}</TableCell>
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje2_049_d:'-'}</TableCell>         
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje2_051_d:'-'}</TableCell> 
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje2_052_d:'-'}</TableCell>
                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listDonat[0]?listDonat[0].stanje2_053_d:'-'}</TableCell>
                                                </TableRow>


                                            </div>



                                        <TableRow className={styles['nadzori-row-header']} onClick={() => {
                                                    //setModalRowToBeShown(modalRowToBeShown=='t-modal' ? "" : "t-modal")
                                                    setModalRowToBeShown(modalRowToBeShown=='all' ? "" : "all")
                                        }}
                                           //</TableBody>*} key={state.rbr}*
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                            <TableCell component="th" scope="row" sx={{paddingTop: 0.6, paddingBottom: 0.6, fontWeight:600}} >
                                                T-mobile ukupno redaka
                                            </TableCell>

                                            <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, fontWeight:600, borderRight:1}}  align="right">{listUkupno[0]?listUkupno[0].stanjeUk_t:'-'}</TableCell>

                                            {listAll.map((row) => (
                                            
                                            (row.mreza!='099'&&row.mreza!='098')?
                                            (<TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, fontWeight:600, borderRight:1}}  align="right">{row.stanjeAll_t?row.stanjeAll_t:'-'}</TableCell>):(<></>)

                                            ))}
                                        </TableRow>
                                            <div style={{display:(modalRowToBeShown=="t-modal" || modalRowToBeShown=='all') ? "contents" : "none"}}>
                                                <TableRow
                                                //</TableBody>*} key={state.rbr}*
                                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                    >
                                                    <TableCell component="th" scope="row" sx={{paddingTop: 0.6, paddingBottom: 0.6}} >
                                                        T-mobile 0
                                                    </TableCell>  

                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}}  align="right">{listUkupno[0]?listUkupno[0].stanjeUk_0_t:'-'}</TableCell>

                                                    {listAll.map((row) => (
                                                    
                                                    (row.mreza!='099'&&row.mreza!='098')?
                                                    (<TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}}  align="right">{row.stanje0_t?row.stanje0_t:'-'}</TableCell>):(<></>)

                                                    ))}
                                                </TableRow>

                                                <TableRow
                                                //</TableBody>*} key={state.rbr}*
                                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                    >
                                                    <TableCell component="th" scope="row" sx={{paddingTop: 0.6, paddingBottom: 0.6}} >
                                                        T-mobile 6
                                                    </TableCell>

                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listUkupno[0]?listUkupno[0].stanjeUk_6_t:'-'}</TableCell>

                                                    {listAll.map((row) => (
                                                    
                                                    (row.mreza!='099'&&row.mreza!='098')?
                                                    (<TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{row.stanje6_t?row.stanje6_t:'-'}</TableCell>):(<></>)

                                                    ))}
                                                </TableRow>        
                                                <TableRow
                                              
                                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                    >
                                                    <TableCell component="th" scope="row" sx={{paddingTop: 0.6, paddingBottom: 0.6}} >
                                                        T-mobile 0,1,3,5,6
                                                    </TableCell>

                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}}  align="right">{listUkupno[0]?listUkupno[0].stanjeUk_01356_t:'-'}</TableCell>

                                                    {listAll.map((row) => (
                                                    
                                                    (row.mreza!='099'&&row.mreza!='098')?
                                                    (<TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{row.stanje01356_t?row.stanje01356_t:'-'}</TableCell>):(<></>)

                                                    ))}
                                                </TableRow>

                                                <TableRow
                                              
                                                    //sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                    >
                                                    <TableCell component="th" scope="row" sx={{paddingTop: 0.6, paddingBottom: 0.6}} >
                                                        T-mobile 2,0
                                                    </TableCell>

                                                    <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}}  align="right">{listUkupno[0]?listUkupno[0].stanjeUk_2_t:'-'}</TableCell>

                                                    {listAll.map((row) => (
                                                    
                                                    (row.mreza!='099'&&row.mreza!='098')?
                                                    (<TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}}  align="right">{row.stanje2_t?row.stanje2_t:'-'}</TableCell>):(<></>)

                                                    ))}
                                                </TableRow>
    

                                            </div>


                                            <TableRow className={styles['nadzori-row-header']} onClick={() => {
                                                //setModalRowToBeShown(modalRowToBeShown=='ostali' ? "" : "ostali")
                                                setModalRowToBeShown(modalRowToBeShown=='all' ? "" : "all")
                                                }}
                                           //</TableBody>*} key={state.rbr}*
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                            <TableCell component="th" scope="row" sx={{paddingTop: 0.6, paddingBottom: 0.6, fontWeight:600}} >
                                                Ostali ukupno redaka
                                            </TableCell>

                                            <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, fontWeight:600, borderRight:1}}  align="right">{listUkupno[0]?listUkupno[0].stanjeUk_o:'-'}</TableCell>

                                            {listAll.map((row) => (
                                            
                                            (row.mreza!='099'&&row.mreza!='098')?
                                            (<TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, fontWeight:600, borderRight:1}}  align="right">{row.stanjeAll_o?row.stanjeAll_o:'-'}</TableCell>):(<></>)

                                            ))}
                                        </TableRow>
                                        <div style={{display:(modalRowToBeShown=="ostali" || modalRowToBeShown=="all") ? "contents" : "none"}}>
                                            <TableRow
                                            //</TableBody>*} key={state.rbr}*
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                >
                                                <TableCell component="th" scope="row" sx={{paddingTop: 0.6, paddingBottom: 0.6}} >
                                                    Ostali 0
                                                </TableCell>

                                                <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}}  align="right">{listUkupno[0]?listUkupno[0].stanjeUk_0_o:'-'}</TableCell>


                                                {listAll.map((row) => (
                                                
                                                (row.mreza!='099'&&row.mreza!='098')?
                                                (<TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{row.stanje0_o?row.stanje0_o:'-'}</TableCell>):(<></>)

                                                ))}
                                            </TableRow>

                                            <TableRow
                                            //</TableBody>*} key={state.rbr}*
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                >
                                                <TableCell component="th" scope="row" sx={{paddingTop: 0.6, paddingBottom: 0.6}} >
                                                    Ostali 6
                                                </TableCell>

                                                <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listUkupno[0]?listUkupno[0].stanjeUk_6_o:'-'}</TableCell>

                                                {listAll.map((row) => (
                                                
                                                (row.mreza!='099'&&row.mreza!='098')?
                                                (<TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{row.stanje6_o?row.stanje6_o:'-'}</TableCell>):(<></>)

                                                ))}
                                            </TableRow>        
                                            <TableRow
                                            //</TableBody>*} key={state.rbr}*
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                >
                                                <TableCell component="th" scope="row" sx={{paddingTop: 0.6, paddingBottom: 0.6}} >
                                                    Ostali 0,1,3,5,6
                                                </TableCell>

                                                <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}}  align="right">{listUkupno[0]?listUkupno[0].stanjeUk_01356_o:'-'}</TableCell>

                                                {listAll.map((row) => (
                                                
                                                (row.mreza!='099'&&row.mreza!='098')?
                                                (<TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}}  align="right">{row.stanje01356_o?row.stanje01356_o:'-'}</TableCell>):(<></>)

                                                ))}
                                            </TableRow>   

                                            <TableRow
                                           
                                                //sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                >
                                                <TableCell component="th" scope="row" sx={{paddingTop: 0.6, paddingBottom: 0.6}} >
                                                    Ostali 2,0
                                                </TableCell>

                                                <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}}  align="right">{listUkupno[0]?listUkupno[0].stanjeUk_2_o:'-'}</TableCell>

                                                {listAll.map((row) => (
                                                
                                                (row.mreza!='099'&&row.mreza!='098')?
                                                (<TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}}  align="right">{row.stanje2_o?row.stanje2_o:'-'}</TableCell>):(<></>)

                                                ))}
                                            </TableRow>

                                            </div>



                                            <TableRow className={styles['nadzori-row-header']} onClick={() => {
                                                //setModalRowToBeShown(modalRowToBeShown=='telemach' ? "" : "telemach")
                                                setModalRowToBeShown(modalRowToBeShown=='all' ? "" : "all")
                                            }}
                                           //</TableBody>*} key={state.rbr}*
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                            <TableCell component="th" scope="row" sx={{paddingTop: 0.6, paddingBottom: 0.6, fontWeight:600}} >
                                                Telemach ukupno redaka
                                            </TableCell>

                                            <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, fontWeight:600, borderRight:1}}  align="right">{listUkupno[0]?listUkupno[0].stanjeUk_tele:'-'}</TableCell>

                                            {listAll.map((row) => (
                                            
                                            (row.mreza!='099'&&row.mreza!='098')?
                                            (<TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, fontWeight:600, borderRight:1}}  align="right">{row.stanjeAll_tele?row.stanjeAll_tele:'-'}</TableCell>):(<></>)

                                            ))}
                                        </TableRow>

                                        <div style={{display:(modalRowToBeShown=="telemach" || modalRowToBeShown=="all")? "contents" : "none"}}>
                                            <TableRow
                                            //</TableBody>*} key={state.rbr}*
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                >
                                                <TableCell component="th" scope="row" sx={{paddingTop: 0.6, paddingBottom: 0.6}} >
                                                    Telemach 0
                                                </TableCell>

                                                <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}}  align="right">{listUkupno[0]?listUkupno[0].stanjeUk_0_tele:'-'}</TableCell>

                                                {listAll.map((row) => (
                                                
                                                (row.mreza!='099'&&row.mreza!='098')?
                                                (<TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}}  align="right">{row.stanje0_tele?row.stanje0_tele:'-'}</TableCell>):(<></>)

                                                ))}
                                            </TableRow>

                                            <TableRow
                                            //</TableBody>*} key={state.rbr}*
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                >
                                                <TableCell component="th" scope="row" sx={{paddingTop: 0.6, paddingBottom: 0.6}} >
                                                    Telemach 6
                                                </TableCell>

                                                <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}}  align="right">{listUkupno[0]?listUkupno[0].stanjeUk_6_tele:'-'}</TableCell>

                                                {listAll.map((row) => (
                                                
                                                (row.mreza!='099'&&row.mreza!='098')?
                                                (<TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}}  align="right">{row.stanje6_tele?row.stanje6_tele:'-'}</TableCell>):(<></>)

                                                ))}
                                            </TableRow>        
                                            <TableRow
                                            //</TableBody>*} key={state.rbr}*
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                >
                                                <TableCell component="th" scope="row" sx={{paddingTop: 0.6, paddingBottom: 0.6}} >
                                                    Telemach 0,1,3,5,6
                                                </TableCell>

                                                <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}}  align="right">{listUkupno[0]?listUkupno[0].stanjeUk_01356_tele:'-'}</TableCell>

                                                {listAll.map((row) => (
                                                
                                                (row.mreza!='099'&&row.mreza!='098')?
                                                (<TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}}  align="right">{row.stanje01356_tele?row.stanje01356_tele:'-'}</TableCell>):(<></>)

                                                ))}
                                            </TableRow>     

                                            <TableRow
                                           
                                                //sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                >
                                                <TableCell component="th" scope="row" sx={{paddingTop: 0.6, paddingBottom: 0.6}} >
                                                    Telemach 2,0
                                                </TableCell>

                                                <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}}  align="right">{listUkupno[0]?listUkupno[0].stanjeUk_2_tele:'-'}</TableCell>

                                                {listAll.map((row) => (
                                                
                                                (row.mreza!='099'&&row.mreza!='098')?
                                                (<TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}}  align="right">{row.stanje2_tele?row.stanje2_tele:'-'}</TableCell>):(<></>)

                                                ))}
                                            </TableRow>
  

                                        </div>

                                        <TableRow className={styles['nadzori-row-header']} onClick={() => {
                                                //setModalRowToBeShown(modalRowToBeShown=='a1' ? "" : "a1")
                                                setModalRowToBeShown(modalRowToBeShown=='all' ? "" : "all")
                                        }}
                                           //</TableBody>*} key={state.rbr}*
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                            <TableCell component="th" scope="row" sx={{paddingTop: 0.6, paddingBottom: 0.6, fontWeight:600}} >
                                                A1 ukupno redaka
                                            </TableCell>

                                            <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, fontWeight:600, borderRight:1}}  align="right">{listUkupno[0]?listUkupno[0].stanjeUk_a:'-'}</TableCell>

                                            {listAll.map((row) => (
                                            
                                            (row.mreza!='099'&&row.mreza!='098')?
                                            (<TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, fontWeight:600, borderRight:1}}  align="right">{row.stanjeAll_a?row.stanjeAll_a:'-'}</TableCell>):(<></>)

                                            ))}
                                        </TableRow>
                                        <div style={{display:(modalRowToBeShown=="a1" || modalRowToBeShown=="all")? "contents" : "none"}}>

                                            <TableRow
                                            //</TableBody>*} key={state.rbr}*
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                >
                                                <TableCell component="th" scope="row" sx={{paddingTop: 0.6, paddingBottom: 0.6,}} >
                                                    A1 0
                                                </TableCell>

                                                <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listUkupno[0]?listUkupno[0].stanjeUk_0_a:'-'}</TableCell>

                                                {listAll.map((row) => (
                                                
                                                (row.mreza!='099'&&row.mreza!='098')?
                                                (<TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{row.stanje0_a?row.stanje0_a:'-'}</TableCell>):(<></>)

                                                ))}
                                            </TableRow>

                                            <TableRow
                                            //</TableBody>*} key={state.rbr}*
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                >
                                                <TableCell component="th" scope="row" sx={{paddingTop: 0.6, paddingBottom: 0.6,}} >
                                                    A1 6
                                                </TableCell>
                                                
                                                <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}}  align="right">{listUkupno[0]?listUkupno[0].stanjeUk_6_a:'-'}</TableCell>

                                                {listAll.map((row) => (
                                                
                                                (row.mreza!='099'&&row.mreza!='098')?
                                                (<TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}}  align="right">{row.stanje6_a?row.stanje6_a:'-'}</TableCell>):(<></>)

                                                ))}
                                            </TableRow>        
                                            <TableRow
                                            //</TableBody>*} key={state.rbr}*
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                >
                                                <TableCell component="th" scope="row" sx={{paddingTop: 0.6, paddingBottom: 0.6,}} >
                                                    A1 0,1,3,5,6
                                                </TableCell>
                                                <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{listUkupno[0]?listUkupno[0].stanjeUk_01356_a:'-'}</TableCell>

                                                {listAll.map((row) => (
                                                
                                                (row.mreza!='099'&&row.mreza!='098')?
                                                (<TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}} align="right">{row.stanje01356_a?row.stanje01356_a:'-'}</TableCell>):(<></>)

                                                ))}
                                            </TableRow>     

                                            <TableRow
                                           
                                                //sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                >
                                                <TableCell component="th" scope="row" sx={{paddingTop: 0.6, paddingBottom: 0.6,}} >
                                                    A1 2,0
                                                </TableCell>

                                                <TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}}  align="right">{listUkupno[0]?listUkupno[0].stanjeUk_2_a:'-'}</TableCell>

                                                {listAll.map((row) => (
                                                
                                                (row.mreza!='099'&&row.mreza!='098')?
                                                (<TableCell sx={{paddingTop: 0.6, paddingBottom: 0.6, borderRight:1}}  align="right">{row.stanje2_a?row.stanje2_a:'-'}</TableCell>):(<></>)

                                                ))}
                                            </TableRow>
                                                       
                                        </div>


                                </TableBody>
                            </Table>
                </TableContainer>
                </Box>
                </Modal>

            <div className={styles.mainContainer}>

                {/*Pocetni screen*/}
                {displayedComponent === null && <PocetniScreenKomponenta />}

                {/*Trenutno stanje spiskova*/}

                {displayedComponent === 'div2' && <TrenutnoStanjeSpiskovaKomponenta />}

                
                {displayedComponent === 'div3' && <FiltriranjePoOperatorima />} 

            </div>
        </ThemeProvider>
    )

}

export default NadzoriUpravljanjeDnevnimSpiskovima;